/* eslint-disable no-lone-blocks */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Suspense, useRef } from 'react';
import { Stats, OrbitControls, Circle, useGLTF, Environment, Text, Line, Cone, Box, Cylinder } from '@react-three/drei';
import { Canvas, useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { useParams } from 'react-router-dom';
import * as THREE from 'three';

function Qline(props) {
  let para = useParams();
  let [colorr, setcolorr] = useState(null);
  const { nodes, materials } = useGLTF('/QLineConfigurator.gltf');
  const group = useRef();
  const groupfacia = useRef();
  const groupcorner = useRef();
  const [letsmountdifferently, setletsmountdifferently] = useState(false);

  useEffect(() => {
    renderpostsystem;
  }, [props]);

  let [undergroundcolor, setundergroundcolor] = useState('#C0C0C0');

  let InputvalueI = parseInt(props.len1);
  let InputvalueL = parseInt(props.len2);
  let InputvalueU = parseInt(props.len3);

  if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
    if (props.form == 'u') {
      InputvalueI = InputvalueI - 250;
      InputvalueL = InputvalueL - 500;
      InputvalueU = InputvalueU - 250;
    }
    if (props.form == 'l') {
      InputvalueI = InputvalueI - 250;
      InputvalueL = InputvalueL - 250;
    }
  }
  if (props.montageart == 'top' && props.postshape == '60x30') {
    if (props.form == 'l') {
      InputvalueL = InputvalueL - 250;
      InputvalueI = InputvalueI - 250;
    }
    if (props.form == 'u') {
      InputvalueI = InputvalueI - 250;
      InputvalueL = InputvalueL - 500;
      InputvalueU = InputvalueU - 250;
    }
  }

  //activate the modus

  useEffect(() => {
    if (props.montageart == 'top' && props.qlineinfill == 'cables') {
      if (props.postshape == 'round' && props.qlineinfill == 'cables' && props.form != 'i') {
        setletsmountdifferently(true);
      } else {
        setletsmountdifferently(false);
      }
    } else {
      setletsmountdifferently(false);
    }
  }, [props.postshape, props.qlineinfill, props.form]);
  //approach to readjust different infills letsmountdiffernetly

  // 1m 40x40 1m 42;; 1.2m 60x30;1.2m 48 /// fascia:: 900mm 40x40 900mm 42;; 1.1m 60x30;1.1m 48
  if (letsmountdifferently) {
    if (props.form == 'u') {
      InputvalueL = InputvalueL - 115;
    } else {
      InputvalueL = InputvalueL - 115;
    }
  }

  const [postdistancevalue, setpostdistancevalue] = useState(1);

  useEffect(() => {
    if (props.montageart == 'top') {
      if (props.postshape == '40x40') {
        setpostdistancevalue(1);
      }
      if (props.postshape == 'round' && props.pfostenrund != '48') {
        setpostdistancevalue(1);
      }
      if (props.postshape == 'round' && props.pfostenrund == '48') {
        setpostdistancevalue(1.2);
      }
      if (props.postshape == '60x30') {
        setpostdistancevalue(1.2);
      }
    }
    if (props.montageart != 'top') {
      if (props.postshape == '40x40') {
        setpostdistancevalue(0.9);
      }
      if (props.postshape == 'round' && props.pfostenrund != '48') {
        setpostdistancevalue(0.9);
      }
      if (props.postshape == 'round' && props.pfostenrund == '48') {
        setpostdistancevalue(1.1);
      }
      if (props.postshape == '60x30') {
        setpostdistancevalue(1.1);
      }
    }
  }, [props.postshape, props.pfostenrund, props.montageart]);

  InputvalueI = InputvalueI / 1000;
  InputvalueL = InputvalueL / 1000;
  InputvalueU = InputvalueU / 1000;
  let amountI = InputvalueI / postdistancevalue;
  let amountL = InputvalueL / postdistancevalue;
  let amountU = InputvalueU / postdistancevalue;
  const group2 = useRef();
  amountI = parseInt(amountI) + 1;
  amountL = parseInt(amountL) + 1;
  amountU = parseInt(amountU) + 1;

  let railingwidthI = parseFloat((InputvalueI / amountI).toFixed(8));
  let railingwidthL = parseFloat((InputvalueL / amountL).toFixed(8));
  let railingwidthU = parseFloat((InputvalueU / amountU).toFixed(8));

  useEffect(() => {
    if (props.colorr == 'satin316') {
      setcolorr('#C0C0C0');
    }
    if (props.colorr == 'satin304') {
      setcolorr('#D0D5D9');
    }
  }, [props.colorr]);

  useEffect(() => {
    if (props.untergrund == 'holz') {
      setundergroundcolor('#6d3d2d');
    }
    if (props.untergrund == 'metall') {
      setundergroundcolor('#C0C0C0');
    }
    if (props.untergrund == 'beton') {
      setundergroundcolor('white');
    }
  }, [props.untergrund]);

  useEffect(() => {
    floorrender();
    rendersecondmodel();
    measurementrender();
    pfosten40x40();
    pfosten30x60();
    pfostenrund();
  }, [props]);

  function floorrender() {
    let len1 = parseInt(props.len1);
    let len2 = parseInt(props.len2);
    let len3 = parseInt(props.len3);

    if (props.montageart != 'top') {
      len2 = len2 - 500;
      if (props.form == 'l') {
        len2 = len2 + 300;
        len1 = len1 - 250;
      }
    }

    let fasciaadjust = 0;
    let fasciaadjust2 = 0;
    let fasiamove = 0;
    let floorscale = 1;
    let topadjust = 0;
    let walladjust = 0;
    let walladjustx = 0;
    let walladjusty = 0;
    let finadjustfascia = 0;
    let smalladjust = 0;
    let finaladjustvalues = 0;
    let walltopadjust = 1.5;
    let wallscale = 13;
    let lengthadjust = 0;

    let cablemountTopI = 0;
    let cablemountTopL = 0;
    let cablemountTopU = 0;
    //new
    let topmove = 0.05;
    let fineflooradjust = 0;
    let fineflooradjustL = 0;
    let fineflooradjustU = 0;

    let WalladjustI = 0;
    let WalladjustL = 0;
    let WalladjustU = 0;
    let WalladjustSoloI = 0;

    let floorheightmove = 0;
    let adjustLfascia = 0;
    let Lfasciascale = 0;
    let floorwidthscaler = 2;
    let flangeUmove = 0;
    let flangefascia = 0;
    {
      props.form == 'i' &&
        props.montageart == 'top' &&
        ((fineflooradjust = 0.35), (WalladjustI = +0.5), (WalladjustSoloI = -0.35));
    }
    {
      props.form == 'l' &&
        props.montageart == 'top' &&
        props.qlineinfill != 'cables' &&
        ((fineflooradjustL = 0.35), (adjustLfascia = -0.35), (WalladjustL = 0.35), (WalladjustI = +0.45));
    }
    {
      props.form == 'u' &&
        props.montageart == 'top' &&
        props.qlineinfill != 'cables' &&
        ((fineflooradjustU = 0.35), (adjustLfascia = -0.35), (WalladjustI = 0.55), (WalladjustU = 0.55));
    }
    {
      props.form == 'l' &&
        props.montageart != 'top' &&
        props.qlineinfill != 'cables' &&
        ((adjustLfascia = 1.6), (Lfasciascale = 0.3), (WalladjustL = 0.5), (WalladjustI = -1.9));
    }
    {
      props.form == 'u' &&
        props.montageart != 'top' &&
        props.qlineinfill != 'cables' &&
        ((fineflooradjust = 0.45), (WalladjustI = 0.55), (WalladjustU = 0.55));
    }

    {
      props.form == 'l' && props.qlineinfill == 'cables' && ((cablemountTopI = 0.45), (cablemountTopL = 0.85));
    }

    {
      props.form == 'u' && props.qlineinfill == 'cables' && ((cablemountTopI = 0.45), (cablemountTopU = 0.45));
    }

    if (props.montageart != 'top') {
      fasciaadjust = 1.5;
      topmove = 0;
      flangefascia = 0.5;
      wallscale = 15;
      fasiamove = 2.5;
      floorscale = 2.8;
      topadjust = 3.5;
      walladjust = 0.94;
      walladjusty = 0;
      floorheightmove = 0.25;
      finaladjustvalues = 2.5;
      walltopadjust = 0.5;

      if (props.form != 'i') {
        fasciaadjust2 = 1.5;
      }

      if (props.montageart != 'top') {
        smalladjust = 0.5;
        props.form == 'i' && ((finadjustfascia = 1.5), (walladjustx = 2.55));
        props.form == 'l' && (walladjusty = 2.25);
      }
      if (props.form == 'i') {
        finaladjustvalues = 0.5;
        WalladjustSoloI = -0.45;
        WalladjustI = 0.1;
      }
      if (props.form == 'l') {
        lengthadjust = 1.8;
      }
      if (props.form == 'u') {
        lengthadjust = 2;
      }
    }
    if (props.form == 'i' && props.postshape == '60x30' && props.montageart == 'top') {
      wallscale = 15;
      fasiamove = 2.5;

      walladjust = 1.42;
      walladjusty = 0;
      finaladjustvalues = 2.5;
      walltopadjust = 0.5;
      finadjustfascia = 1.5;
      walladjustx = 2.55;
      finaladjustvalues = 0.5;
      smalladjust = 0.5;

      fineflooradjust = -0.05;
    }

    {
      props.montageart == 'top' && (floorwidthscaler = 2.4);
    }
    let handrailWalladjust = 0;
    let texture;
    if (props.handlaufmat == '60x30') {
      handrailWalladjust = 0.097;
    }
    let wall1soloi = 0;

    if (props.montageart == 'top' && props.form == 'i') {
      wall1soloi = 0.05;
    }

    try {
      //eslint-disable-next-line
      texture = useLoader(
        THREE.TextureLoader,
        'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/concrete-texture.jpg',
      );
    } catch (error) {
      console.error('Error loading texture:', error);
      texture = null;
    }

    {
      props.qlineinfill == 'cables' &&
        props.form != 'i' &&
        ((WalladjustI = -0.25), (WalladjustL = 0.75), (WalladjustU = -0.45), (flangeUmove = 0.389));
    }
    let wallconnectorscale = [0.45, 0.45, 0.45];

    if (props.handlaufmat == '60x30') {
      wallconnectorscale = [0.45, 0.4, 0.7];
    }
    {
      props.qlineinfill == 'cables' && (WalladjustU = -0.2);
    }

    return (
      <>
        <Box
          scale={[len1 / 100, floorscale, floorwidthscaler]}
          position={[len1 / 200 + fasiamove - lengthadjust, -0.5 - floorheightmove, 0 + fasciaadjust + topmove]}
          material-color={undergroundcolor}
          material-map={texture}
        ></Box>
        <Box
          scale={[2 + Lfasciascale, floorscale, floorwidthscaler]}
          position={[
            len1 / 100 + fasiamove - smalladjust - lengthadjust - fineflooradjust + adjustLfascia + cablemountTopI,
            -0.5 - floorheightmove,
            0 + fasciaadjust + topmove,
          ]}
          material-color={undergroundcolor}
          material-map={texture}
        ></Box>

        {(props.form == 'l' || props.form == 'u') && (
          <Box
            scale={[floorwidthscaler, floorscale, len2 / 100]}
            position={[0 + fasciaadjust + topmove, -0.5 - floorheightmove, len2 / 200 + fasiamove + topmove]}
            material-color={undergroundcolor}
            material-map={texture}
          ></Box>
        )}
        {props.form == 'u' && (
          <Box
            scale={[len3 / 100, floorscale, floorwidthscaler]}
            position={[
              len3 / 200 + fasiamove - lengthadjust,
              -0.5 - floorheightmove,
              len2 / 100 - fasciaadjust + fasiamove * 2 - topmove,
            ]}
            material-color={undergroundcolor}
            material-map={texture}
          ></Box>
        )}
        {(props.form == 'u' || props.form == 'l' || props.form == 'i') && (
          <Box
            scale={[floorwidthscaler, floorscale, floorwidthscaler]}
            position={[
              0 + fasciaadjust2 + finadjustfascia * 2 + topmove + fineflooradjust,
              -0.5 - floorheightmove,
              0 + fasciaadjust + topmove,
            ]}
            material-color={undergroundcolor}
            material-map={texture}
          ></Box>
        )}

        {props.form == 'u' && (
          <Box
            scale={[floorwidthscaler, floorscale, floorwidthscaler]}
            position={[
              0 + fasciaadjust + topmove,
              -0.5 - floorheightmove,
              len2 / 100 - fasciaadjust + fasiamove * 2 - topmove,
            ]}
            material-color={undergroundcolor}
            material-map={texture}
          ></Box>
        )}
        {props.form == 'u' && (
          <Box
            scale={[2, floorscale, floorwidthscaler]}
            position={[
              len3 / 100 + fasiamove - lengthadjust - fineflooradjustU + cablemountTopU,
              -0.5 - floorheightmove,
              len2 / 100 - fasciaadjust + fasiamove * 2 - topmove,
            ]}
            material-color={undergroundcolor}
            material-map={texture}
            visible={props.montageart != 'top' ? false : true}
          ></Box>
        )}
        {props.form == 'l' && (
          <>
            <Box
              scale={[floorwidthscaler, floorscale, floorwidthscaler]}
              position={[
                0 + fasciaadjust + topmove,
                -0.5 - floorheightmove,
                len2 / 100 - fineflooradjustL - cablemountTopL,
              ]}
              material-color={undergroundcolor}
              material-map={texture}
              visible={props.montageart != 'top' ? false : true}
            ></Box>
          </>
        )}

        {/*Wall */}

        {props.wall1 && (
          <>
            <Box
              scale={[1.5, wallscale, 3.1]}
              position={[
                len1 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustI + 0.1 + wall1soloi,
                7 - walladjust - walltopadjust - floorheightmove,
                0,
              ]}
              material-color={'#333'}
              material-map={texture}
            ></Box>
            {props.handlaufmat != 'round' && (
              <Box
                position={[
                  len1 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustI - 0.6,
                  11 - handrailWalladjust,
                  0,
                ]}
                scale={wallconnectorscale}
                material-color={'#838487'}
              ></Box>
            )}
            {props.handlaufmat == 'round' && (
              <Cylinder
                position={[
                  len1 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustI - 0.6 - 0.1,
                  11 - handrailWalladjust,
                  0,
                ]}
                scale={[0.25, 0.25, 0.25]}
                rotation-y={Math.PI / 1}
                rotation-z={-Math.PI / 2}
                material-color={'#838487'}
              ></Cylinder>
            )}
          </>
        )}
        {props.wall2 && props.form == 'u' && (
          <>
            <Box
              scale={[1.5, wallscale, 3.1]}
              position={[
                len3 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustU + 0.1,
                7 - walladjust - walltopadjust - floorheightmove,
                len2 / 100 + fasciaadjust * 3 + flangefascia,
              ]}
              material-color={'#333'}
              material-map={texture}
            ></Box>
            {props.handlaufmat != 'round' && (
              <Box
                position={[
                  len3 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustU - 0.6,
                  11 - handrailWalladjust,
                  len2 / 100 + fasciaadjust * 3 + flangefascia + flangeUmove,
                ]}
                scale={wallconnectorscale}
                material-color={'#838487'}
              ></Box>
            )}
            {props.handlaufmat == 'round' && (
              <Cylinder
                position={[
                  len3 / 100 + fasiamove + 1.8 - finaladjustvalues - WalladjustU - 0.6 - 0.1,
                  11 - handrailWalladjust,
                  len2 / 100 + fasciaadjust * 3 + flangefascia + flangeUmove,
                ]}
                scale={[0.25, 0.25, 0.25]}
                rotation-y={Math.PI / 1}
                rotation-z={-Math.PI / 2}
                material-color={'#838487'}
              ></Cylinder>
            )}
          </>
        )}
        {props.wall2 && props.form == 'i' && (
          <>
            <Box
              scale={[1.5, wallscale, 3.1]}
              position={[
                0 - 1.7 + walladjustx - WalladjustSoloI - 0.1,
                7 - walladjust - walltopadjust - floorheightmove,
                0,
              ]}
              material-color={'#333'}
              material-map={texture}
            ></Box>
            {props.handlaufmat != 'round' && (
              <Box
                position={[0 - 1.7 + walladjustx - WalladjustSoloI + 0.6, 11 - handrailWalladjust, 0]}
                scale={wallconnectorscale}
                material-color={'#838487'}
              ></Box>
            )}
            {props.handlaufmat == 'round' && (
              <Cylinder
                position={[0 - 1.7 + walladjustx - WalladjustSoloI + 0.6 + 0.1, 11 - handrailWalladjust, 0]}
                scale={[0.25, 0.25, 0.25]}
                rotation-y={Math.PI / 1}
                rotation-z={-Math.PI / 2}
                material-color={'#838487'}
              ></Cylinder>
            )}
          </>
        )}
        {props.wall2 && props.form == 'l' && (
          <>
            <Box
              scale={[3.1, wallscale, 1.5]}
              position={[
                0,
                7 - walladjust - walltopadjust - floorheightmove,
                props.len2 / 100 + 1.6 - WalladjustL + 0.2,
              ]}
              material-color={'#333'}
              material-map={texture}
            ></Box>

            {props.handlaufmat != 'round' && (
              <Box
                position={[0, 11 - handrailWalladjust, props.len2 / 100 + 1.6 - WalladjustL - 0.6]}
                scale={wallconnectorscale}
                material-color={'#838487'}
              ></Box>
            )}
            {props.handlaufmat == 'round' && (
              <Cylinder
                position={[0, 11 - handrailWalladjust, props.len2 / 100 + 1.6 - WalladjustL - 0.6 - 0.05]}
                scale={[0.25, 0.25, 0.25]}
                rotation-y={Math.PI / 2}
                rotation-z={-Math.PI / 2}
                material-color={'#838487'}
              ></Cylinder>
            )}
          </>
        )}
      </>
    );
  }
  const measurementrender = () => {
    if (props.montageart == 'top' || props.montageart != 'fascia') {
      let movevalues = 0;

      let xmove = 0;
      let ymove = 0;
      let cornerx = 0;
      let fasciaadjustx = 0;
      let fasciacorners = 0;
      let measurestart = -1.8;

      let finetuneI = 0;
      let finetuneL = 0;
      let finetuneU = 0;
      let leaderlineheight = 0.0001;
      if (props.montageart == 'top') {
        xmove = 0.6;
        ymove = 0.6;
        if (props.form == 'l' || props.form == 'u') {
          cornerx = 0.4;
          ymove = 0.95;
        }
      } else {
        xmove = 0.4;
        ymove = 0.4;
        if (props.form == 'l' || props.form == 'u') {
          cornerx = -0.4;
          ymove = -0.65;
          xmove = -0.3;
        }
      }

      if (
        (props.montageart == 'top' && props.form == 'i' && props.postshape == '60x30') ||
        (props.montageart != 'top' && props.form == 'i')
      ) {
        movevalues = 2.5;
      }

      if (props.montageart != 'top' && props.form != 'i') {
        fasciaadjustx = 0.15;
        measurestart = -2.2;
        leaderlineheight = 0.6;
      }
      {
        props.form == 'u' && props.montageart != 'top' && ((finetuneI = 0.82), (finetuneU = 1));
      }
      {
        props.form == 'u' && props.montageart == 'top' && (finetuneU = -0.45);
      }
      {
        props.form == 'l' && props.montageart == 'top' && (finetuneL = -0.25);
      }
      {
        props.form == 'l' && props.montageart != 'top' && ((finetuneI = 0.79), (finetuneL = 0.87));
      }

      // Round spak mode Cable
      {
        props.form == 'u' && props.qlineinfill == 'cables' && ((finetuneI = 0.79), (finetuneU = 0.45));
      }
      {
        props.form == 'l' && props.qlineinfill == 'cables' && ((finetuneI = 0.79), (finetuneL = -0.75));
      }

      let handrailjump = 11.2;
      let fasiaheightjump = 0;
      let heightnumber = '1100mm';

      if (props.montageart == 'top') {
        {
          props.postshape == '60x30' && props.handlaufmat == '60x30' && (heightnumber = '1100mm');
        }
        {
          props.postshape == '40x40' && props.handlaufmat == 'square' && (heightnumber = '1110mm');
        }
        {
          props.postshape == '60x30' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '48' &&
            (heightnumber = '1128mm');
        }
        {
          props.postshape == 'round' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '48' &&
            (heightnumber = '1117mm');
        }
        {
          props.postshape == 'round' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '42' &&
            (heightnumber = '1110mm');
        }
        {
          props.postshape == '40x40' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '42' &&
            (heightnumber = '1110mm');
        }
      }

      if (para.count == 'en-us' || para.count == 'es-us') {
        {
          heightnumber == '1100mm' && (heightnumber = '43.31"');
        }
        {
          heightnumber == '1110mm' && (heightnumber = '43.70"');
        }
        {
          heightnumber == '1128mm' && (heightnumber = '44.42"');
        }
        {
          heightnumber == '1117mm' && (heightnumber = '43.98"');
        }

        {
          props.postshape == '40x40' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '42' &&
            (heightnumber = '43.59"');
        }
        {
          props.postshape == '40x40' && props.handlaufmat == 'square' && (heightnumber = '43.66"');
        }
        {
          props.postshape == 'round' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '48' &&
            (heightnumber = '43.05"');
        }
        {
          props.postshape == 'round' &&
            props.handlaufmat == 'round' &&
            props.qlinehandlauf == '42' &&
            (heightnumber = '42.65"');
        }
        {
          props.montageart != 'top' && (heightnumber = '42"');
        }
      }

      {
        props.montageart != 'top' && (fasiaheightjump = 0.5);
      }

      return (
        <>
          <group>
            {/*Height*/}

            {!props.wall1 && (
              <>
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 3, fasiaheightjump, 0],
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 3, handrailjump, 0],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 1, handrailjump, 0],
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 3.2, handrailjump, 0],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 1, fasiaheightjump, 0],
                    [props.len1 / 100 + movevalues + xmove + finetuneI + 3.2, fasiaheightjump, 0],
                  ]}
                  dashed={false}
                />

                <Text
                  color={'black'}
                  position={[props.len1 / 100 + movevalues + xmove + finetuneI + 5.5, 5.5, 0]}
                  rotation-y={props.polarcoord}
                  scale={[1, 1, 1]}
                >
                  {heightnumber}
                </Text>
                <Cone
                  position={[
                    props.len1 / 100 - 0.15 + movevalues + xmove + finetuneI + 3.14,
                    fasiaheightjump + 0.18,
                    0,
                  ]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={-Math.PI / 2}
                  rotation-y={Math.PI / 2}
                  rotation-z={-Math.PI / 2}
                />
                <Cone
                  position={[props.len1 / 100 - 0.15 + movevalues + xmove + finetuneI + 3.14, handrailjump - 0.18, 0]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={-Math.PI / 2}
                  rotation-y={-Math.PI / 2}
                  rotation-z={-Math.PI / 2}
                />
              </>
            )}
            {props.wall1 && (
              <>
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, fasiaheightjump, 0 - 3],
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, handrailjump, 0 - 3],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, handrailjump, 0 - 1],
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, handrailjump, 0 - 3.2],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, fasiaheightjump, 0 - 1],
                    [props.len1 / 100 + movevalues + xmove + finetuneI - 1, fasiaheightjump, 0 - 3.2],
                  ]}
                  dashed={false}
                />

                <Text
                  color={'black'}
                  position={[props.len1 / 100 + movevalues + xmove + finetuneI - 1, 5.5, -5.3]}
                  rotation-y={props.polarcoord}
                  scale={[1, 1, 1]}
                >
                  {heightnumber}
                </Text>
                <Cone
                  position={[
                    props.len1 / 100 - 0.15 + movevalues + xmove + finetuneI - 0.85,
                    fasiaheightjump + 0.18,
                    0 - 3,
                  ]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={-Math.PI / 2}
                  rotation-y={Math.PI / 2}
                  rotation-z={-Math.PI / 2}
                />
                <Cone
                  position={[
                    props.len1 / 100 - 0.15 + movevalues + xmove + finetuneI - 0.85,
                    handrailjump - 0.18,
                    0 - 3,
                  ]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={-Math.PI / 2}
                  rotation-y={-Math.PI / 2}
                  rotation-z={-Math.PI / 2}
                />
              </>
            )}
            {/*Leader line*/}
            {/*props.montageart == 'top' && props.form != 'i' && (
              <>
                <Line
                  points={[
                    [props.len1 / 200, 0, -1],
                    [props.len1 / 200, 6, 0 - 8],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 200, 6, 0 - 8],
                    [props.len1 / 200, 6, 0 - 12.5],
                  ]}
                  dashed={false}
                />

                <Text
                  color={'black'}
                  position={[props.len1 / 200, 6.8, 0 - 10.5]}
                  rotation-y={props.polarcoord}
                  scale={[1, 1, 1]}
                >
                  {para.count != ('en-us' || 'es-us') ? '100 mm' : parseFloat(100 / 25.4).toFixed(2) + ' "'}
                </Text>
                <Cone
                  position={[props.len1 / 200, 0.1, 0 - 1.1]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation={[0.7084 + Math.PI / 2, 0, 0]}
                />

                <Line
                  points={[
                    [props.len1 / 200, leaderlineheight, 0],
                    [props.len1 / 200, leaderlineheight, -1.16],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 200 + 0.2, leaderlineheight, -1.18],
                    [props.len1 / 200 - 0.2, leaderlineheight, -1.18],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [props.len1 / 200 + 0.2, leaderlineheight, 0],
                    [props.len1 / 200 - 0.2, leaderlineheight, 0],
                  ]}
                  dashed={false}
                />
              </>
            )*/}

            {/*Width*/}

            <Line
              points={[
                [0 + movevalues - xmove - cornerx - fasciaadjustx, -4, 0 - ymove - fasciaadjustx],
                [props.len1 / 100 + movevalues + xmove + finetuneI, -4, 0 - ymove - fasciaadjustx],
              ]}
              dashed={false}
            />
            <Line
              points={[
                [props.len1 / 100 + movevalues + xmove + finetuneI, measurestart, 0 - ymove - fasciaadjustx],
                [props.len1 / 100 + movevalues + xmove + finetuneI, -4.2, 0 - ymove - fasciaadjustx],
              ]}
              dashed={false}
            />
            <Line
              points={[
                [0 + movevalues - xmove - cornerx - fasciaadjustx, measurestart, 0 - ymove - fasciaadjustx],
                [0 + movevalues - xmove - cornerx - fasciaadjustx, -4.2, 0 - ymove - fasciaadjustx],
              ]}
              dashed={false}
            />
            <Text
              color={'black'}
              position={[props.len1 / 200 + movevalues, -3, -cornerx - xmove - fasciaadjustx]}
              rotation-y={props.polarcoord}
              scale={[1, 1, 1]}
            >
              A :{' '}
              {para.count != ('en-us' || 'es-us')
                ? props.len1 + ' mm'
                : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
            </Text>
            <Cone
              position={[0.15 + movevalues - xmove - cornerx - fasciaadjustx, -4, 0 - ymove - fasciaadjustx]}
              scale={[0.1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
            <Cone
              position={[props.len1 / 100 - 0.15 + movevalues + xmove + finetuneI, -4, 0 - ymove - fasciaadjustx]}
              scale={[0.1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={-Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
          </group>
          {(props.form == 'l' || props.form == 'u') && (
            <>
              <group>
                <Line
                  points={[
                    [0 - cornerx - xmove - fasciaadjustx, -4, 0 - xmove - cornerx - fasciaadjustx],
                    [
                      0 - cornerx - xmove - fasciaadjustx,
                      -4,
                      props.len2 / 100 + xmove + cornerx + fasciaadjustx + finetuneL,
                    ],
                  ]}
                  dashed={false}
                />
                <Line
                  points={[
                    [
                      0 - xmove - cornerx - fasciaadjustx,
                      -4.2,
                      props.len2 / 100 + xmove + cornerx + fasciaadjustx + finetuneL,
                    ],
                    [
                      0 - xmove - cornerx - fasciaadjustx,
                      measurestart,
                      props.len2 / 100 + xmove + cornerx + fasciaadjustx + finetuneL,
                    ],
                  ]}
                  dashed={false}
                />
                <Text
                  color={'black'}
                  position={[0 - cornerx - xmove - fasciaadjustx, -3, props.len2 / 200]}
                  rotation-y={props.polarcoord}
                  scale={[1, 1, 1]}
                >
                  B :{' '}
                  {para.count != ('en-us' || 'es-us')
                    ? props.len2 + ' mm'
                    : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
                </Text>
                <Cone
                  position={[
                    0 - cornerx - xmove - fasciaadjustx,
                    -4,
                    props.len2 / 100 - 0.15 + xmove + cornerx + fasciaadjustx + finetuneL,
                  ]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={Math.PI / 2}
                />
                <Cone
                  position={[0 - cornerx - xmove - fasciaadjustx, -4, 0 + 0.15 - cornerx - xmove - fasciaadjustx]}
                  scale={[0.1, 0.4, 0.1]}
                  material-color={'black'}
                  rotation-x={-Math.PI / 2}
                />
              </group>
              {props.form == 'u' && (
                <group>
                  <Line
                    points={[
                      [0 - cornerx - xmove - fasciaadjustx, -4, props.len2 / 100 + cornerx + xmove + fasciaadjustx],
                      [
                        props.len3 / 100 + cornerx + xmove + fasciaadjustx + finetuneU,
                        -4,
                        props.len2 / 100 + cornerx + xmove + fasciaadjustx,
                      ],
                    ]}
                    dashed={false}
                  />
                  <Line
                    points={[
                      [
                        props.len3 / 100 + cornerx + xmove + fasciaadjustx + finetuneU,
                        measurestart,
                        props.len2 / 100 + cornerx + xmove + fasciaadjustx,
                      ],
                      [
                        props.len3 / 100 + cornerx + xmove + fasciaadjustx + finetuneU,
                        -4.2,
                        props.len2 / 100 + cornerx + xmove + fasciaadjustx,
                      ],
                    ]}
                    dashed={false}
                  />
                  <Text
                    color={'black'}
                    position={[props.len3 / 200, -3, props.len2 / 100 + cornerx + xmove + fasciaadjustx]}
                    rotation-y={props.polarcoord}
                    scale={[1, 1, 1]}
                  >
                    C :{' '}
                    {para.count != ('en-us' || 'es-us')
                      ? props.len3 + ' mm'
                      : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
                  </Text>
                  <Cone
                    position={[
                      0.15 - cornerx - xmove - fasciaadjustx,
                      -4,
                      props.len2 / 100 + cornerx + xmove + fasciaadjustx,
                    ]}
                    scale={[0.1, 0.4, 0.1]}
                    material-color={'black'}
                    rotation-x={Math.PI / 2}
                    rotation-z={Math.PI / 2}
                  />
                  <Cone
                    position={[
                      props.len3 / 100 - 0.15 + cornerx + xmove + fasciaadjustx + finetuneU,
                      -4,
                      props.len2 / 100 + cornerx + xmove + fasciaadjustx,
                    ]}
                    scale={[0.1, 0.4, 0.1]}
                    material-color={'black'}
                    rotation-x={-Math.PI / 2}
                    rotation-z={-Math.PI / 2}
                  />
                </group>
              )}
            </>
          )}
        </>
      );
    }
  };

  function rendersecondmodel() {
    let scalorfactor = 0.95;
    //eslint-disable-next-line
    const { nodes, materials } = useGLTF('/QLineConfiguratorFacia.gltf');

    {
      props.montageart != 'top' && (scalorfactor = 1);
    }
    let materialcolor = '#C0C0C0';
    let seconmodelmeshes = [];
    let fasciapostadjust = 0;
    let len1 = parseInt(props.len1);
    let len2 = parseInt(props.len2);
    let len3 = parseInt(props.len3);
    let letsmountadjust = 0;
    if (props.montageart != 'top') {
      fasciapostadjust = 0.25;
    }
    //Fascia flanges für fascia mount
    if (props.montageart != 'top') {
      for (let i = 0; i < amountI + 1; i++) {
        if (props.postshape == 'round') {
          seconmodelmeshes.push(
            <mesh
              scale={[10, 10, 10]}
              position={[0 + i * railingwidthI * 10 + fasciapostadjust * 10, -1.5, +0.5]}
              material={nodes.RoundFasciaFlange.material}
              geometry={nodes.RoundFasciaFlange.geometry}
              rotation={[0, 0, -Math.PI / 2]}
              material-color={'#C0C0C0'}
            />,
          );
        }
        if (props.postshape == '40x40') {
          seconmodelmeshes.push(
            <>
              {props.postshape == '40x40' && (
                <mesh
                  scale={[10, 10, 10]}
                  position={[0 + i * railingwidthI * 10 + fasciapostadjust * 10, -1.5, +0.5]}
                  material={nodes['4040FasciaFlange'].material}
                  geometry={nodes['4040FasciaFlange'].geometry}
                  material-color={'#C0C0C0'}
                />
              )}
            </>,
          );
        }
        if (props.postshape == '60x30') {
          seconmodelmeshes.push(
            <>
              <mesh
                material={nodes['60x30FasciaFlange'].material}
                geometry={nodes['60x30FasciaFlange'].geometry}
                position={[0 + i * railingwidthI * 10 + fasciapostadjust * 10, -1.5, +0.5]}
                rotation={[Math.PI / 2, 0, 0]}
                material-color={'#C0C0C0'}
                scale={[10, 10, 10]}
              />
            </>,
          );
        }
      }

      if (props.form == 'l' || props.form == 'u') {
        for (let i = 0; i < amountL + 1; i++) {
          if (props.postshape == 'round') {
            seconmodelmeshes.push(
              <mesh
                scale={[10, 10, 10]}
                position={[0 + 0.5, -1.5, 0 + i * railingwidthL * 10 + fasciapostadjust * 10]}
                material={nodes.RoundFasciaFlange.material}
                geometry={nodes.RoundFasciaFlange.geometry}
                material-color={'#C0C0C0'}
                rotation={[0, Math.PI / 2, -Math.PI / 2]}
              />,
            );
          }
          if (props.postshape == '40x40') {
            seconmodelmeshes.push(
              <>
                <mesh
                  scale={[10, 10, 10]}
                  position={[0 + 0.5, -1.5, 0 + i * railingwidthL * 10 + fasciapostadjust * 10]}
                  rotation={[0, Math.PI / 2, 0]}
                  material={nodes['4040FasciaFlange'].material}
                  material-color={'#C0C0C0'}
                  geometry={nodes['4040FasciaFlange'].geometry}
                />
              </>,
            );
          }
          if (props.postshape == '60x30') {
            seconmodelmeshes.push(
              <>
                <mesh
                  material={nodes['60x30FasciaFlange'].material}
                  geometry={nodes['60x30FasciaFlange'].geometry}
                  scale={[10, 10, 10]}
                  position={[0 + 0.5, -1.5, 0 + i * railingwidthL * 10 + fasciapostadjust * 10]}
                  rotation={[Math.PI / 2, 0, (Math.PI * 3) / 2]}
                  material-color={'#C0C0C0'}
                />
              </>,
            );
          }
        }
        if (props.form == 'u') {
          for (let i = 0; i < amountU + 1; i++) {
            if (props.postshape == 'round') {
              seconmodelmeshes.push(
                <mesh
                  scale={[10, 10, 10]}
                  position={[
                    0 + i * railingwidthU * 10 + fasciapostadjust * 10,
                    -1.5,
                    0 + amountL * railingwidthL * 10 - 0.5 + fasciapostadjust * 20,
                  ]}
                  material={nodes.RoundFasciaFlange.material}
                  geometry={nodes.RoundFasciaFlange.geometry}
                  material-color={'#C0C0C0'}
                  rotation={[0, Math.PI, -Math.PI / 2]}
                />,
              );
            }
            if (props.postshape == '40x40') {
              seconmodelmeshes.push(
                <>
                  <mesh
                    scale={[10, 10, 10]}
                    position={[
                      0 + i * railingwidthU * 10 + fasciapostadjust * 10,
                      -1.5,
                      0 + amountL * railingwidthL * 10 - 0.5 + fasciapostadjust * 20,
                    ]}
                    material={nodes['4040FasciaFlange'].material}
                    material-color={'#C0C0C0'}
                    rotation={[0, Math.PI, 0]}
                    geometry={nodes['4040FasciaFlange'].geometry}
                  />
                </>,
              );
            }
            if (props.postshape == '60x30') {
              seconmodelmeshes.push(
                <mesh
                  material={nodes['60x30FasciaFlange'].material}
                  geometry={nodes['60x30FasciaFlange'].geometry}
                  position={[
                    0 + i * railingwidthU * 10 + fasciapostadjust * 10,
                    -1.5,
                    0 + amountL * railingwidthL * 10 - 0.5 + fasciapostadjust * 20,
                  ]}
                  rotation={[Math.PI / 2, 0, Math.PI]}
                  material-color={'#C0C0C0'}
                  scale={[10, 10, 10]}
                />,
              );
            }
          }
        }
      }
    }
    if (letsmountdifferently) {
      if (props.postshape == 'round') {
        letsmountadjust = 0.75;
      } else {
        letsmountadjust = 1.15;
      }
    }
    if (props.qlineinfill == 'cables' || props.qlineinfill == 'verticalbars' || props.qlineinfill == '20x10') {
      //eigentlich ja horizontalbars

      let scalorfactor = 0.95;

      {
        props.montageart != 'top' && (scalorfactor = 1);
      }
      for (let i = 0; i < 10; i++) {
        let adjustfactor = i * scalorfactor;
        let fasciaadjustment = 0;
        let fasciaelongation = 0;
        props.form == 'i' && props.montageart != 'top' && (fasciaadjustment = 2.5);
        props.montageart != 'top' && props.form != 'i' && (fasciaelongation = 250);
        props.form == 'i' && props.montageart == 'top' && props.postshape == '60x30' && (fasciaadjustment = 2.5);
        fasciaelongation = 0;

        if (props.qlineinfill == 'verticalbars') {
          seconmodelmeshes.push(
            <mesh
              material-color={'#C0C0C0'}
              material={nodes.HSstab.material}
              scale={[10, (len1 + fasciaelongation) / 100, 10]}
              geometry={nodes.HSstab.geometry}
              rotation={[0, 0, Math.PI / 2]}
              position={[0 + fasciaadjustment + letsmountadjust, 9.8 - i * scalorfactor, 0 - 0.3]}
            />,
          );
        }
        if (props.qlineinfill == '20x10') {
          seconmodelmeshes.push(
            <Box
              scale={[0.1, (len1 + fasciaelongation) / 100, 0.2]}
              rotation={[0, 0, Math.PI / 2]}
              material-color={'#C0C0C0'}
              position={[0 + (len1 + fasciaelongation) / 200, 9.8 - i * scalorfactor, 0 - 0.3]}
            />,
          );
        }

        if (props.form == 'l' || props.form == 'u') {
          if (props.qlineinfill == 'verticalbars') {
            seconmodelmeshes.push(
              <mesh
                material-color={'#C0C0C0'}
                material={nodes.HSstab.material}
                scale={[10, len2 / 100, 10]}
                geometry={nodes.HSstab.geometry}
                rotation={[0, -Math.PI / 2, Math.PI / 2]}
                position={[0 - 0.3, 9.8 - i * scalorfactor, 0]}
              />,
            );
          }
          if (props.qlineinfill == '20x10') {
            seconmodelmeshes.push(
              <Box
                scale={[0.1, (len2 + fasciaelongation) / 100, 0.2]}
                rotation={[0, Math.PI / 2, Math.PI / 2]}
                material-color={'#838487'}
                position={[0 - 0.3, 9.8 - i * scalorfactor, 0 + (len2 + fasciaelongation) / 200]}
              />,
            );
          }
          if (props.form == 'u') {
            if (props.qlineinfill == 'verticalbars') {
              seconmodelmeshes.push(
                <mesh
                  material={nodes.HSstab.material}
                  geometry={nodes.HSstab.geometry}
                  material-color={'#C0C0C0'}
                  position={[0, 9.8 - i * scalorfactor, len2 / 100 + 0.3]}
                  rotation={[Math.PI, 0, Math.PI / 2]}
                  scale={[10, (len3 + fasciaelongation) / 100, 10]}
                />,
              );
            }
            if (props.qlineinfill == '20x10') {
              seconmodelmeshes.push(
                <Box
                  scale={[0.1, (len3 + fasciaelongation) / 100, 0.2]}
                  rotation={[0, 0, Math.PI / 2]}
                  material-color={'#C0C0C0'}
                  position={[
                    0 + (len3 + fasciaelongation) / 200,
                    9.8 - i * scalorfactor,
                    0 + (len2 + fasciaelongation) / 100 + 0.4,
                  ]}
                />,
              );
            }
          }
        }
      }

      for (let i = 0; i < 12; i++) {
        let adjustfactor = i * scalorfactor;
        let fasciaadjustment = 0;
        let fasciaelongation = 0;
        scalorfactor = 0.8;
        props.form == 'i' && props.montageart != 'top' && (fasciaadjustment = 2.5);
        props.montageart != 'top' && props.form != 'i' && (fasciaelongation = 250);
        props.form == 'i' && props.montageart == 'top' && props.postshape == '60x30' && (fasciaadjustment = 2.5);
        fasciaelongation = 0;
        if (props.qlineinfill == 'cables') {
          seconmodelmeshes.push(
            <mesh
              material-color={'#C0C0C0'}
              material={nodes.Draht.material}
              geometry={nodes.Draht.geometry}
              position={[0 + fasciaadjustment + letsmountadjust, 9.8 - i * scalorfactor, 0]}
              rotation={[0, 0, -Math.PI / 2]}
              scale={[10, (len1 + fasciaelongation) / 100, 10]}
            />,
          );
        }

        if (props.form == 'l' || props.form == 'u') {
          if (props.qlineinfill == 'cables') {
            seconmodelmeshes.push(
              <mesh
                material-color={'#C0C0C0'}
                material={nodes.Draht.material}
                geometry={nodes.Draht.geometry}
                position={[0, 9.8 - i * scalorfactor, (len2 - letsmountadjust * 75) / 100]}
                rotation={[0, Math.PI / 2, -Math.PI / 2]}
                scale={[10, (len2 - letsmountadjust * 200) / 100, 10]}
              />,
            );
          }

          if (props.form == 'u') {
            if (props.qlineinfill == 'cables') {
              seconmodelmeshes.push(
                <mesh
                  material={nodes.Draht.material}
                  geometry={nodes.Draht.geometry}
                  material-color={'#C0C0C0'}
                  position={[0 + letsmountadjust, 9.8 - i * scalorfactor, len2 / 100 + letsmountadjust / 1.5]}
                  rotation={[0, 0, -Math.PI / 2]}
                  scale={[10, len3 / 100, 10]}
                />,
              );
            }
          }
        }
      }
    }
    if (props.qlineinfill == 'pickets') {
      seconmodelmeshes.push(
        <mesh
          material={nodes.HSstab.material}
          scale={[10, len1 / 100, 10]}
          geometry={nodes.HSstab.geometry}
          rotation={[0, 0, Math.PI / 2]}
          position={[0, 1, 0 - 0.3]}
        />,
        <mesh
          material={nodes.HSverbinder.material}
          geometry={nodes.HSverbinder.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[10, 10, 10]}
          position={[0, 1, 0 - 0.3]}
        />,
        <mesh
          material={nodes.HSstab.material}
          scale={[10, len1 / 100, 10]}
          geometry={nodes.HSstab.geometry}
          rotation={[0, 0, Math.PI / 2]}
          position={[0, 9.8, 0 - 0.3]}
        />,
      );
      if (props.form == 'l' || props.form == 'u') {
        seconmodelmeshes.push(
          <mesh
            material={nodes.HSstab.material}
            scale={[10, len2 / 100, 10]}
            geometry={nodes.HSstab.geometry}
            rotation={[0, -Math.PI / 2, Math.PI / 2]}
            position={[0 - 0.3, 1, 0]}
          />,
          <mesh
            material={nodes.HSstab.material}
            scale={[10, len2 / 100, 10]}
            geometry={nodes.HSstab.geometry}
            rotation={[0, -Math.PI / 2, Math.PI / 2]}
            position={[0 - 0.3, 9.8, 0]}
          />,
        );
        if (props.form == 'u') {
          seconmodelmeshes.push(
            <mesh
              material={nodes.HSstab.material}
              scale={[10, len3 / 100, 10]}
              geometry={nodes.HSstab.geometry}
              rotation={[0, 0, Math.PI / 2]}
              position={[0, 1, len2 / 100 + 0.3]}
            />,
            <mesh
              material={nodes.HSstab.material}
              scale={[10, len3 / 100, 10]}
              geometry={nodes.HSstab.geometry}
              rotation={[0, 0, Math.PI / 2]}
              position={[0, 9.8, len2 / 100 + 0.3]}
            />,
          );
        }
      }
      let amountIpickets = len1 / 100;
      let amountLpickets = len2 / 10;
      let amountUpickets = len3 / 10;

      for (let i = 0; i < amountIpickets + 1; i++) {
        seconmodelmeshes.push(
          <mesh
            material={nodes.VSstab.material}
            scale={[10, 9.5, 10]}
            position={[0 + i, 0.8, -0.5]}
            geometry={nodes.VSstab.geometry}
          />,
          <mesh
            material={nodes.VSverbinder.material}
            position={[0 + i, 1, -0.65]}
            scale={[10, 10, 10]}
            geometry={nodes.VSverbinder.geometry}
          />,
          <mesh
            material={nodes.VSverbinder.material}
            position={[0 + i, 9.78, -0.65]}
            scale={[10, 10, 10]}
            geometry={nodes.VSverbinder.geometry}
          />,
        );
      }
    }
    //stöpsel oder connector
    if (props.qlineinfill == 'verticalbars') {
      let scalorfactor = 0.95;

      {
        props.montageart != 'top' && (scalorfactor = 1);
      }
      let pfostenwidthadjust = 0.1;
      let fasciaadjust = 0;
      if (props.montageart != 'top' || (props.montageart == 'top' && props.postshape == '60x30')) {
        fasciaadjust = -2.5;
      }
      if (props.pfostenrund == '48') {
        pfostenwidthadjust = 0.13;
      }
      if (props.postshape == '60x30') {
        pfostenwidthadjust = 0.2;
      }
      for (let i = 0; i < amountI + 1; i++) {
        for (let u = 0; u < 10; u++) {
          let adjustfactor = u * scalorfactor;

          seconmodelmeshes.push(
            <mesh
              material={nodes.HSverbinder.material}
              geometry={nodes.HSverbinder.geometry}
              rotation={[-Math.PI / 2, 0, 0]}
              material-color={'#C0C0C0'}
              position={[0 + i * railingwidthI * 10 - fasciaadjust, 10 - adjustfactor - 0.2, -0.2 - pfostenwidthadjust]}
              scale={[10, 10, 10]}
            />,
          );
        }
      }

      if (props.form == 'l' || props.form == 'u') {
        for (let i = 0; i < amountL + 1; i++) {
          for (let u = 0; u < 10; u++) {
            let adjustfactor = u * scalorfactor;

            seconmodelmeshes.push(
              <mesh
                material={nodes.HSverbinder.material}
                geometry={nodes.HSverbinder.geometry}
                rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                material-color={'#C0C0C0'}
                position={[
                  0 - 0.2 - pfostenwidthadjust,
                  10 - adjustfactor - 0.2,
                  i * railingwidthL * 10 - fasciaadjust,
                ]}
                scale={[10, 10, 10]}
              />,
            );
          }
        }
        if (props.form == 'u') {
          for (let i = 0; i < amountU + 1; i++) {
            for (let u = 0; u < 10; u++) {
              let adjustfactor = u * scalorfactor;
              let addadjust = 0;
              if (props.montageart == 'top' && props.postshape == '60x30') {
                addadjust = 2.5;
              }
              if (props.montageart != 'top') {
                addadjust = 2.5;
              }
              seconmodelmeshes.push(
                <mesh
                  material={nodes.HSverbinder.material}
                  geometry={nodes.HSverbinder.geometry}
                  rotation={[-Math.PI / 2, 0, 0]}
                  material-color={'#C0C0C0'}
                  position={[
                    0 + i * railingwidthU * 10 - fasciaadjust,
                    10 - adjustfactor - 0.2,
                    amountL * railingwidthL * 10 - fasciaadjust + pfostenwidthadjust + 0.1 + addadjust,
                  ]}
                  scale={[10, 10, 10]}
                />,
              );
            }
          }
        }
      }
    }

    return seconmodelmeshes;
    /*return (
      <group ref={group2} {...props} dispose={null} scale={[10, 10, 10]}>
        <mesh
          material={nodes['4040FasciaFlange'].material}
          material-color={materialcolor}
          geometry={nodes['4040FasciaFlange'].geometry}
        />
        <mesh
          material={nodes['60x30FasciaFlange'].material}
          geometry={nodes['60x30FasciaFlange'].geometry}
          position={[0, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          material={nodes.RoundFasciaFlange.material}
          geometry={nodes.RoundFasciaFlange.geometry}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh
          material={nodes.VSframe.material}
          geometry={nodes.VSframe.geometry}
          position={[0, 0, 0]}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh material={nodes.VSstab.material} geometry={nodes.VSstab.geometry} />
        <mesh material={nodes.VSverbinder.material} geometry={nodes.VSverbinder.geometry} />
        <mesh material={nodes.Draht.material} geometry={nodes.Draht.geometry} rotation={[0, 0, -Math.PI / 2]} />
        <mesh
          material={nodes.Drahtstopper.material}
          geometry={nodes.Drahtstopper.geometry}
          position={[0, 0, 0]}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh material={nodes.HSstab.material} geometry={nodes.HSstab.geometry} rotation={[0, 0, Math.PI / 2]} />
        <mesh
          material={nodes.HSverbinder.material}
          geometry={nodes.HSverbinder.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
        />
      </group>
    );*/
  }
  function pfosten40x40() {
    const meshes = [];

    for (let i = 0; i < amountI + 1; i++) {
      let phase = 3;
      let phase2 = 3;
      if (i == 0) {
        phase = 2;
        phase2 = 3;
        if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
          phase = 3;
          phase2 = 3;
        }
      }
      if (i == amountI) {
        phase = 3;
        phase2 = 0;
      }
      let fasciapostadjust = 0;
      if (props.montageart != 'top') {
        fasciapostadjust = 0.25;
      }
      if (letsmountdifferently) {
        fasciapostadjust = 0.115;
      }

      meshes.push(
        <group position={[0 + i * railingwidthI + fasciapostadjust, 0, 0]}>
          <group position={[0, 1.1, 0.02]} visible={false} comment="corner40x40">
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40HandrailCorner1'].geometry}
              position={[0, 0, 0]}
              rotation={[0, 0, -Math.PI]}
              comment="Corner"
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40HandrailCorner2'].geometry}
              position={[-0.02, 0, -0.02]}
              rotation={[Math.PI, -1.57, 0]}
            />
          </group>
          <mesh
            comment="Ich glaube Pfosten 40x40"
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['40x40Profile'].geometry}
            position={[0, 0, 0]}
          />
          {props.montageart != 'top' && (
            <Box
              scale={[0.0399, 0.4, 0.0399]}
              position={[0, 0.1 - 0.08, 0]}
              material={materials.AluAltPhysicalEngine}
            ></Box>
          )}
          <Box scale={[0.0399, 1, 0.0399]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['40x40FloorFlange'].geometry}
            position={[0, 0.01, 0]}
            visible={props.montageart == 'top' ? true : false}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['40x40HandrailBracket'].geometry}
            position={[0, 1, 0]}
          />
          <mesh
            visible={false}
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['40x40Handrail'].geometry}
            position={[0, 1.1, 0]}
          />
          {props.montageart == 'top' && (
            <>
              {i != 0 && (
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Flat'].geometry}
                  position={[0, 1, 0]}
                />
              )}
              {i != 0 && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation={[0, 0, 0]}
                />
              )}
              {i == 0 && props.form != 'i' && (
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['90Flat'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI}
                />
              )}
              {i == 0 && props.form != 'i' && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['90Round'].geometry}
                  position={[0, 1, 0]}
                  comment="PfostenCornerPlatteUnterHandrail"
                  rotation-y={Math.PI}
                />
              )}

              {props.form == 'i' && i === 0 && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation={[0, 0, 0]}
                />
              )}
            </>
          )}

          {props.montageart != 'top' && (
            <>
              <mesh
                visible={props.handlaufmat != 'round' ? true : false}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['180Flat'].geometry}
                position={[0, 1, 0]}
              />

              <mesh
                visible={props.handlaufmat == 'round' ? true : false}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['180Round'].geometry}
                position={[0, 1, 0]}
                rotation={[0, 0, 0]}
              />
            </>
          )}

          {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
        </group>,
      );
    }

    if (props.form == 'l' || props.form == 'u') {
      for (let i = 0; i < amountL + 1; i++) {
        let phase = 1;
        let phase2 = 1;
        if (i == 0) {
          phase = 1;
          phase2 = 2;
          if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
            phase2 = 1;
          }
        }
        if (i == amountL) {
          phase = 2;
          phase2 = 1;

          if (props.form == 'l') {
            phase = 0;
          }
          if (props.montageart != 'top' && props.form == 'u') {
            phase = 1;
          }
        }
        let fasciapostadjust = 0;
        if (props.montageart != 'top') {
          fasciapostadjust = 0.25;
        }
        if (letsmountdifferently) {
          fasciapostadjust = 0.115;
        }

        meshes.push(
          <group position={[0, 0, 0 + i * railingwidthL + fasciapostadjust]}>
            <group position={[0, 1.1, 0.02]} visible={false} comment="corner40x40">
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40HandrailCorner1'].geometry}
                position={[0, 0, 0]}
                rotation={[0, 0, -Math.PI]}
                comment="Corner"
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40HandrailCorner2'].geometry}
                position={[-0.02, 0, -0.02]}
                rotation={[Math.PI, -1.57, 0]}
              />
            </group>
            <mesh
              comment="Ich glaube Pfosten 40x40"
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40Profile'].geometry}
              position={[0, 0, 0]}
            />
            <Box scale={[0.0399, 1, 0.0399]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
            {props.montageart != 'top' && (
              <Box
                scale={[0.0399, 0.4, 0.0399]}
                position={[0, 0.1 - 0.08, 0]}
                material={materials.AluAltPhysicalEngine}
              ></Box>
            )}
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40FloorFlange'].geometry}
              position={[0, 0.01, 0]}
              visible={props.montageart == 'top' ? true : false}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40HandrailBracket'].geometry}
              position={[0, 1, 0]}
            />
            <mesh
              visible={false}
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['40x40Handrail'].geometry}
              position={[0, 1.1, 0]}
            />
            {props.montageart == 'top' && (
              <>
                {i != 0 && i != amountL && (
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
                {i != 0 && i != amountL && (
                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}

                {i == amountL && props.form == 'l' && (
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
                {i == amountL && props.form == 'l' && (
                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
              </>
            )}

            {props.montageart != 'top' && (
              <>
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Flat'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI / 2}
                />

                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI / 2}
                />
              </>
            )}

            {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
          </group>,
        );
      }
      if (props.form == 'u') {
        for (let i = 0; i < amountU + 1; i++) {
          let phase2 = 3;
          let phase = 3;
          if (i == 0) {
            phase = 2;
            phase2 = 1;
            if (props.montageart != 'top' && props.form == 'u') {
              phase2 = 0;
            }
          }
          if (i == amountU) {
            phase = 3;
            phase2 = 0;
          }
          let fasciapostadjust = 0;
          if (props.montageart != 'top') {
            fasciapostadjust = 0.25;
          }
          if (letsmountdifferently) {
            fasciapostadjust = 0.115;
          }

          meshes.push(
            <group
              position={[
                0 + i * railingwidthU + fasciapostadjust,
                0,
                0 + amountL * railingwidthL + fasciapostadjust * 2,
              ]}
            >
              <group position={[0, 1.1, 0.02]} visible={false} comment="corner40x40">
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40HandrailCorner1'].geometry}
                  position={[0, 0, 0]}
                  rotation={[0, 0, -Math.PI]}
                  comment="Corner"
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40HandrailCorner2'].geometry}
                  position={[-0.02, 0, -0.02]}
                  rotation={[Math.PI, -1.57, 0]}
                />
              </group>
              <mesh
                comment="Ich glaube Pfosten 40x40"
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40Profile'].geometry}
                position={[0, 0, 0]}
              />
              <Box scale={[0.0399, 1, 0.0399]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
              {props.montageart != 'top' && (
                <Box
                  scale={[0.0399, 0.4, 0.0399]}
                  position={[0, 0.1 - 0.08, 0]}
                  material={materials.AluAltPhysicalEngine}
                ></Box>
              )}
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40FloorFlange'].geometry}
                position={[0, 0.01, 0]}
                visible={props.montageart == 'top' ? true : false}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40HandrailBracket'].geometry}
                position={[0, 1, 0]}
              />
              <mesh
                visible={false}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['40x40Handrail'].geometry}
                position={[0, 1.1, 0]}
              />
              {props.montageart == 'top' && (
                <>
                  {i != 0 && (
                    <mesh
                      visible={props.handlaufmat != 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['180Flat'].geometry}
                      position={[0, 1, 0]}
                    />
                  )}
                  {i != 0 && (
                    <mesh
                      visible={props.handlaufmat == 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['180Round'].geometry}
                      position={[0, 1, 0]}
                      rotation={[0, 0, 0]}
                    />
                  )}
                  {i == 0 && (
                    <mesh
                      visible={props.handlaufmat != 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['90Flat'].geometry}
                      position={[0, 1, 0]}
                      rotation-y={(Math.PI * 3) / 2}
                    />
                  )}
                  {i == 0 && (
                    <mesh
                      visible={props.handlaufmat == 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['90Round'].geometry}
                      position={[0, 1, 0]}
                      comment="PfostenCornerPlatteUnterHandrail"
                      rotation-y={(Math.PI * 3) / 2}
                    />
                  )}
                </>
              )}

              {props.montageart != 'top' && (
                <>
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                  />

                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation={[0, 0, 0]}
                  />
                </>
              )}

              {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
            </group>,
          );
        }
      }
    }
    return meshes;
  }
  function pfosten30x60() {
    const meshes = [];

    for (let i = 0; i < amountI + 1; i++) {
      let phase = 3;
      let phase2 = 3;
      if (i == 0) {
        phase = 2;
        phase2 = 3;
        if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
          phase = 3;
          phase2 = 3;
        }
        if (props.montageart == 'top' && (props.form == 'l' || props.form == 'u') && props.postshape == '60x30') {
          phase = 3;
          phase2 = 3;
        }
      }
      if (i == amountI) {
        phase = 3;
        phase2 = 0;
      }
      let fasciapostadjust = 0;
      if (props.montageart != 'top') {
        fasciapostadjust = 0.25;
      }
      if (props.postshape == '60x30') {
        fasciapostadjust = 0.25;
      }
      if (letsmountdifferently) {
        fasciapostadjust = 0.115;
      }
      meshes.push(
        <group position={[0 + i * railingwidthI + fasciapostadjust, 0, 0]}>
          <group position={[0, 1.1, 0.01]} visible={false} comment="EckigCorner 30x60">
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30HandrailCorner1'].geometry}
              position={[0, 0, 0.01]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30HandrailCorner2'].geometry}
              position={[-0.03, 0, -0.01]}
              rotation={[0, -1.57, 0]}
            />
          </group>
          <Box scale={[0.0299, 1, 0.0599]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
          {props.montageart != 'top' && (
            <Box
              scale={[0.0299, 0.4, 0.0599]}
              position={[0, 0.1 - 0.08, 0]}
              material={materials.AluAltPhysicalEngine}
            ></Box>
          )}
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['60x30FloorFlange'].geometry}
            position={[0, 0, 0]}
            rotation={[Math.PI / 2, 0, Math.PI / 1]}
            visible={props.montageart == 'top' ? true : false}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['60x30HandrailBracketFlat'].geometry}
            position={[0, 1, 0]}
            rotation={[Math.PI / 2, 0, -Math.PI / 1]}
            visible={props.handlaufmat != 'round' ? true : false}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['60x30HandrailBracketRound'].geometry}
            position={[0, 1, 0]}
            rotation={[Math.PI / 2, 0, Math.PI / 1]}
            visible={props.handlaufmat == 'round' ? true : false}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['60x30Handrail'].geometry}
            position={[0, 1.1, 0]}
            visible={false}
          />
          {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
        </group>,
      );
    }

    if (props.form == 'l' || props.form == 'u') {
      for (let i = 0; i < amountL + 1; i++) {
        let phase = 1;
        let phase2 = 1;
        if (i == 0) {
          phase = 1;
          phase2 = 2;
          if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
            phase2 = 1;
          }
          if (props.montageart == 'top' && (props.form == 'l' || props.form == 'u') && props.postshape == '60x30') {
            phase2 = 1;
          }
        }
        if (i == amountL) {
          phase = 2;
          phase2 = 1;

          if (props.form == 'l') {
            phase = 0;
          }
          if (props.montageart != 'top' && props.form == 'u') {
            phase = 1;
          }
          if (props.montageart == 'top' && props.form == 'u' && props.postshape == '60x30') {
            phase = 1;
          }
        }
        let fasciapostadjust = 0;
        if (props.montageart != 'top') {
          fasciapostadjust = 0.25;
        }
        if (props.postshape == '60x30') {
          fasciapostadjust = 0.25;
        }

        if (letsmountdifferently) {
          fasciapostadjust = 0.115;
        }
        meshes.push(
          <group position={[0, 0, 0 + i * railingwidthL + fasciapostadjust]}>
            <group position={[0, 1.1, 0.01]} visible={false} comment="EckigCorner 30x60">
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30HandrailCorner1'].geometry}
                position={[0, 0, 0.01]}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30HandrailCorner2'].geometry}
                position={[-0.03, 0, -0.01]}
                rotation={[0, -1.57, 0]}
              />
            </group>
            <Box scale={[0.0599, 1, 0.0299]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
            {props.montageart != 'top' && (
              <Box
                scale={[0.0599, 0.4, 0.0299]}
                position={[0, 0.1 - 0.08, 0]}
                material={materials.AluAltPhysicalEngine}
              ></Box>
            )}
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30FloorFlange'].geometry}
              position={[0, 0, 0]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              visible={props.montageart == 'top' ? true : false}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30HandrailBracketFlat'].geometry}
              position={[0, 1, 0]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              visible={props.handlaufmat != 'round' ? true : false}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30HandrailBracketRound'].geometry}
              position={[0, 1, 0]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              visible={props.handlaufmat == 'round' ? true : false}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['60x30Handrail'].geometry}
              position={[0, 1.1, 0]}
              visible={false}
            />
            {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
          </group>,
        );
      }
      if (props.form == 'u') {
        for (let i = 0; i < amountU + 1; i++) {
          let phase2 = 3;
          let phase = 3;
          if (i == 0) {
            phase = 2;
            phase2 = 1;
            if (props.montageart != 'top' && props.form == 'u') {
              phase2 = 0;
            }
            if (props.montageart == 'top' && props.form == 'u' && props.postshape == '60x30') {
              phase2 = 0;
            }
          }
          if (i == amountU) {
            phase = 3;
            phase2 = 0;
          }
          let fasciapostadjust = 0;
          if (props.montageart != 'top') {
            fasciapostadjust = 0.25;
          }
          if (props.postshape == '60x30') {
            fasciapostadjust = 0.25;
          }
          if (letsmountdifferently) {
            fasciapostadjust = 0.115;
          }
          meshes.push(
            <group
              position={[
                0 + i * railingwidthU + fasciapostadjust,
                0,
                0 + amountL * railingwidthL + fasciapostadjust * 2,
              ]}
            >
              <group position={[0, 1.1, 0.01]} visible={false} comment="EckigCorner 30x60">
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30HandrailCorner1'].geometry}
                  position={[0, 0, 0.01]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30HandrailCorner2'].geometry}
                  position={[-0.03, 0, -0.01]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <Box scale={[0.0299, 1, 0.0599]} position={[0, 0.499, 0]} material={materials.AluAltPhysicalEngine}></Box>
              {props.montageart != 'top' && (
                <Box
                  scale={[0.0299, 0.4, 0.0599]}
                  position={[0, 0.1 - 0.08, 0]}
                  material={materials.AluAltPhysicalEngine}
                ></Box>
              )}
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30FloorFlange'].geometry}
                position={[0, 0, 0]}
                rotation={[Math.PI / 2, 0, Math.PI / 1]}
                visible={props.montageart == 'top' ? true : false}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30HandrailBracketFlat'].geometry}
                position={[0, 1, 0]}
                rotation={[Math.PI / 2, 0, -Math.PI / 1]}
                visible={props.handlaufmat != 'round' ? true : false}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30HandrailBracketRound'].geometry}
                position={[0, 1, 0]}
                rotation={[Math.PI / 2, 0, Math.PI / 1]}
                visible={props.handlaufmat == 'round' ? true : false}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['60x30Handrail'].geometry}
                position={[0, 1.1, 0]}
                visible={false}
              />
              {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
            </group>,
          );
        }
      }
    }
    return meshes;
  }
  function pfostenrund() {
    let pfostenscale = 0.02;

    if (props.pfostenrund == '48') {
      pfostenscale = 0.024;
    }
    const meshes = [];

    for (let i = 0; i < amountI + 1; i++) {
      let phase = 3;
      let phase2 = 3;
      if (i == 0) {
        phase = 2;
        phase2 = 3;
        if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
          phase = 3;
          phase2 = 3;
        }
      }
      if (i == amountI) {
        phase = 3;
        phase2 = 0;
      }
      let fasciapostadjust = 0;
      if (props.montageart != 'top') {
        fasciapostadjust = 0.25;
      }
      if (letsmountdifferently) {
        fasciapostadjust = 0.075;
      }

      meshes.push(
        <group position={[0 + i * railingwidthI + fasciapostadjust, 0, 0]}>
          <group position={[0, 1.1, 0]} visible={false} comment="rundHandlaufCorner">
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.RoundHandrailCorner1.geometry}
              position={[0, 0, 0.02]}
              rotation={[-Math.PI / 2, 0, 0]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.RoundHandrailCorner2.geometry}
              position={[0, 0, 0]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
            />
          </group>
          <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.RoundProfile.geometry} position={[0, 0, 0]} />
          <Cylinder
            material={materials.AluAltPhysicalEngine}
            scale={[pfostenscale, 1, pfostenscale]}
            position={[0, 0.5, 0]}
          />
          {props.montageart != 'top' && (
            <Cylinder
              material={materials.AluAltPhysicalEngine}
              scale={[pfostenscale, 1, pfostenscale]}
              position={[0, 0.416 - 0.08, 0]}
            />
          )}
          <mesh
            material={materials.AluAltPhysicalEngine}
            visible={props.montageart == 'top' ? true : false}
            geometry={nodes.RoundFloorFlange.geometry}
          />
          <mesh
            comment="HandlaufStütze-Rund"
            material={materials.AluAltPhysicalEngine}
            geometry={nodes.RoundHandrailBracket.geometry}
            position={[-0.33 + 0.002, 1, -0.08 - 0.005]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            comment="Handlauf-Rund"
            material={materials.AluAltPhysicalEngine}
            geometry={nodes.RoundHandrail.geometry}
            position={[0, 1.1, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
            visible={false}
          />

          {props.montageart == 'top' && props.qlineinfill != 'cables' && (
            <>
              {i != 0 && (
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Flat'].geometry}
                  position={[0, 1, 0]}
                />
              )}
              {i != 0 && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation={[0, 0, 0]}
                />
              )}
              {i == 0 && props.form != 'i' && (
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['90Flat'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI}
                />
              )}
              {i == 0 && props.form != 'i' && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['90Round'].geometry}
                  position={[0, 1, 0]}
                  comment="PfostenCornerPlatteUnterHandrail"
                  rotation-y={Math.PI}
                />
              )}

              {props.form == 'i' && i === 0 && (
                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation={[0, 0, 0]}
                />
              )}
            </>
          )}

          {(props.montageart != 'top' || (props.montageart && props.qlineinfill == 'cables')) && (
            <>
              <mesh
                visible={props.handlaufmat != 'round' ? true : false}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['180Flat'].geometry}
                position={[0, 1, 0]}
              />

              <mesh
                visible={props.handlaufmat == 'round' ? true : false}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['180Round'].geometry}
                position={[0, 1, 0]}
                rotation={[0, 0, 0]}
              />
            </>
          )}
          {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
        </group>,
      );
    }

    if (props.form == 'l' || props.form == 'u') {
      for (let i = 0; i < amountL + 1; i++) {
        let phase = 1;
        let phase2 = 1;
        if (i == 0) {
          phase = 1;
          phase2 = 2;
          if (props.montageart != 'top' && (props.form == 'l' || props.form == 'u')) {
            phase2 = 1;
          }
        }
        if (i == amountL) {
          phase = 2;
          phase2 = 1;

          if (props.form == 'l') {
            phase = 0;
          }
          if (props.montageart != 'top' && props.form == 'u') {
            phase = 1;
          }
        }
        let fasciapostadjust = 0;
        if (props.montageart != 'top') {
          fasciapostadjust = 0.25;
        }
        if (letsmountdifferently) {
          fasciapostadjust = 0.075;
        }
        meshes.push(
          <group position={[0, 0, 0 + i * railingwidthL + fasciapostadjust]}>
            <group position={[0, 1.1, 0]} visible={false} comment="rundHandlaufCorner">
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes.RoundHandrailCorner1.geometry}
                position={[0, 0, 0.02]}
                rotation={[-Math.PI / 2, 0, 0]}
              />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes.RoundHandrailCorner2.geometry}
                position={[0, 0, 0]}
                rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
              />
            </group>
            <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.RoundProfile.geometry} />
            <Cylinder
              material={materials.AluAltPhysicalEngine}
              scale={[pfostenscale, 1, pfostenscale]}
              position={[0, 0.5, 0]}
            />
            {props.montageart != 'top' && (
              <Cylinder
                material={materials.AluAltPhysicalEngine}
                scale={[pfostenscale, 1, pfostenscale]}
                position={[0, 0.416 - 0.08, 0]}
              />
            )}
            <mesh
              material={materials.AluAltPhysicalEngine}
              visible={props.montageart == 'top' ? true : false}
              geometry={nodes.RoundFloorFlange.geometry}
            />
            <mesh
              comment="HandlaufStütze-Rund"
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.RoundHandrailBracket.geometry}
              position={[-0.33, 1, -0.08]}
              rotation={[Math.PI / 2, 0, 0]}
            />
            <mesh
              comment="Handlauf-Rund"
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.RoundHandrail.geometry}
              position={[0, 1.1, 0]}
              rotation={[-Math.PI / 2, 0, 0]}
              visible={false}
            />
            {props.montageart == 'top' && props.qlineinfill != 'cables' && (
              <>
                {i != 0 && i != amountL && (
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
                {i != 0 && i != amountL && (
                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}

                {i == amountL && props.form == 'l' && (
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
                {i == amountL && props.form == 'l' && (
                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation-y={Math.PI / 2}
                  />
                )}
              </>
            )}

            {(props.montageart != 'top' || (props.montageart && props.qlineinfill == 'cables')) && (
              <>
                <mesh
                  visible={props.handlaufmat != 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Flat'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI / 2}
                />

                <mesh
                  visible={props.handlaufmat == 'round' ? true : false}
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['180Round'].geometry}
                  position={[0, 1, 0]}
                  rotation-y={Math.PI / 2}
                />
              </>
            )}
            {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
          </group>,
        );
      }
      if (props.form == 'u') {
        for (let i = 0; i < amountU + 1; i++) {
          let phase2 = 3;
          let phase = 3;
          if (i == 0) {
            phase = 2;
            phase2 = 1;
            if (props.montageart != 'top' && props.form == 'u') {
              phase2 = 0;
            }
          }
          if (i == amountU) {
            phase = 3;
            phase2 = 0;
          }
          let fasciapostadjust = 0;
          if (props.montageart != 'top') {
            fasciapostadjust = 0.25;
          }
          if (letsmountdifferently) {
            fasciapostadjust = 0.075;
          }
          meshes.push(
            <group
              position={[
                0 + i * railingwidthU + fasciapostadjust,
                0,
                0 + amountL * railingwidthL + fasciapostadjust * 2,
              ]}
            >
              <group position={[0, 1.1, 0]} visible={false} comment="rundHandlaufCorner">
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrailCorner1.geometry}
                  position={[0, 0, 0.02]}
                  rotation={[-Math.PI / 2, 0, 0]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrailCorner2.geometry}
                  position={[0, 0, 0]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.RoundProfile.geometry} />
              <Cylinder
                material={materials.AluAltPhysicalEngine}
                scale={[pfostenscale, 1, pfostenscale]}
                position={[0, 0.5, 0]}
              />
              {props.montageart != 'top' && (
                <Cylinder
                  material={materials.AluAltPhysicalEngine}
                  scale={[pfostenscale, 1, pfostenscale]}
                  position={[0, 0.416 - 0.08, 0]}
                />
              )}
              <mesh
                material={materials.AluAltPhysicalEngine}
                visible={props.montageart == 'top' ? true : false}
                geometry={nodes.RoundFloorFlange.geometry}
              />
              <mesh
                comment="HandlaufStütze-Rund"
                material={materials.AluAltPhysicalEngine}
                geometry={nodes.RoundHandrailBracket.geometry}
                position={[-0.33, 1, -0.08]}
                rotation={[Math.PI / 2, 0, 0]}
              />
              <mesh
                comment="Handlauf-Rund"
                material={materials.AluAltPhysicalEngine}
                geometry={nodes.RoundHandrail.geometry}
                position={[0, 1.1, 0]}
                rotation={[-Math.PI / 2, 0, 0]}
                visible={false}
              />
              {props.montageart == 'top' && props.qlineinfill != 'cables' && (
                <>
                  {i != 0 && (
                    <mesh
                      visible={props.handlaufmat != 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['180Flat'].geometry}
                      position={[0, 1, 0]}
                    />
                  )}
                  {i != 0 && (
                    <mesh
                      visible={props.handlaufmat == 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['180Round'].geometry}
                      position={[0, 1, 0]}
                      rotation={[0, 0, 0]}
                    />
                  )}
                  {i == 0 && (
                    <mesh
                      visible={props.handlaufmat != 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['90Flat'].geometry}
                      position={[0, 1, 0]}
                      rotation-y={(Math.PI * 3) / 2}
                    />
                  )}
                  {i == 0 && (
                    <mesh
                      visible={props.handlaufmat == 'round' ? true : false}
                      material={materials.AluAltPhysicalEngine}
                      geometry={nodes['90Round'].geometry}
                      position={[0, 1, 0]}
                      comment="PfostenCornerPlatteUnterHandrail"
                      rotation-y={(Math.PI * 3) / 2}
                    />
                  )}
                </>
              )}

              {(props.montageart != 'top' || (props.montageart && props.qlineinfill == 'cables')) && (
                <>
                  <mesh
                    visible={props.handlaufmat != 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Flat'].geometry}
                    position={[0, 1, 0]}
                  />

                  <mesh
                    visible={props.handlaufmat == 'round' ? true : false}
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['180Round'].geometry}
                    position={[0, 1, 0]}
                    rotation={[0, 0, 0]}
                  />
                </>
              )}

              {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && renderklammer('eckig', phase, phase2)}
            </group>,
          );
        }
      }
    }
    return meshes;
  }
  function renderfillings() {
    const infillmesh = [];
    let fasciapostadjust = 0;
    let mountdifferentadjust = 0;
    if (props.montageart != 'top') {
      fasciapostadjust = 0.25;
    }
    if (props.montageart == 'top' && props.postshape == '60x30') {
      fasciapostadjust = 0.25;
    }

    let movetheglass = 0.5;

    if (letsmountdifferently) {
      if (props.postshape == 'round') {
        mountdifferentadjust = 0.75;
      } else {
        mountdifferentadjust = 1.15;
      }
    }
    if (props.qlineinfill == 'glass') {
      for (let i = 0; i < amountI; i++) {
        if (props.qlineinfill == 'glass') {
          infillmesh.push(
            <group
              comment="Glass"
              position={[
                0 + railingwidthI * 5 + i * (railingwidthI * 10) + fasciapostadjust * 10 + mountdifferentadjust,
                -0.08 - movetheglass,
                0,
              ]}
              scale={[10, 10, 10 * (railingwidthI + 0.01)]}
              rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
            >
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
          );
        }
      }

      if (props.form == 'l' || props.form == 'u') {
        for (let i = 0; i < amountL; i++) {
          if (props.qlineinfill == 'glass') {
            infillmesh.push(
              <group
                comment="Glass"
                position={[
                  0,
                  -0.08 - movetheglass,
                  0 + railingwidthL * 5 + i * (railingwidthL * 10) + fasciapostadjust * 10 + mountdifferentadjust,
                ]}
                scale={[10, 10, 10 * (railingwidthL + 0.01)]}
                rotation={[-Math.PI, 0, -Math.PI]}
              >
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
            );
          }
        }
        if (props.form == 'u') {
          for (let i = 0; i < amountU; i++) {
            if (props.qlineinfill == 'glass') {
              if (props.qlineinfill == 'glass') {
                infillmesh.push(
                  <group
                    comment="Glass"
                    position={[
                      0 + railingwidthU * 5 + i * (railingwidthU * 10) + fasciapostadjust * 10 + mountdifferentadjust,
                      -0.08 - movetheglass,
                      railingwidthL * 10 * amountL + fasciapostadjust * 20 + mountdifferentadjust * 2,
                    ]}
                    scale={[10, 10, 10 * (railingwidthU + 0.01)]}
                    rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
                  >
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ1.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ2.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ1.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ2.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ1.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                    <mesh
                      material={materials['Glass Frosted']}
                      geometry={nodes.GlassJ1.geometry}
                      position={[0, 0.6, 0]}
                      rotation={[0, 0, 0]}
                    />
                  </group>,
                );
              }
            }
          }
        }
        //glasscorners for l and u
        if (
          (props.form == 'u' || props.form == 'l') &&
          (props.montageart != 'top' || (props.montageart == 'top' && props.postshape == '60x30')) &&
          props.qlineinfill == 'glass'
        ) {
          infillmesh.push(
            <group
              comment="Glass"
              position={[0, -0.08 - movetheglass, 1.1]}
              scale={[10, 10, 2]}
              rotation={[-Math.PI, 0, -Math.PI]}
            >
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
            <group
              comment="Glass"
              position={[1.1, -0.08 - movetheglass, 0]}
              scale={[10, 10, 2]}
              rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
            >
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
          );

          if (props.form == 'u') {
            infillmesh.push(
              <group
                comment="Glass"
                position={[0, -0.08 - movetheglass, props.len2 / 100 - 1.1]}
                scale={[10, 10, 2]}
                rotation={[-Math.PI, 0, -Math.PI]}
              >
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
              <group
                comment="Glass"
                position={[1.1, -0.08 - movetheglass, props.len2 / 100]}
                scale={[10, 10, 2]}
                rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
              >
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ2.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
                <mesh
                  material={materials['Glass Frosted']}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
            );
          }
        }
      }
    }
    if (props.qlineinfill == 'plates') {
      for (let i = 0; i < amountI; i++) {
        if (props.qlineinfill == 'plates') {
          infillmesh.push(
            <group
              comment="Glass"
              position={[
                0 + railingwidthI * 5 + i * (railingwidthI * 10) + fasciapostadjust * 10,
                -0.08 - movetheglass,
                0,
              ]}
              scale={[10, 10, 10 * (railingwidthI + 0.01)]}
              rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
            >
              <mesh
                material-color={'#293133'}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
          );
        }
      }

      if (props.form == 'l' || props.form == 'u') {
        for (let i = 0; i < amountL; i++) {
          if (props.qlineinfill == 'plates') {
            infillmesh.push(
              <group
                comment="Glass"
                position={[
                  0,
                  -0.08 - movetheglass,
                  0 + railingwidthL * 5 + i * (railingwidthL * 10) + fasciapostadjust * 10,
                ]}
                scale={[10, 10, 10 * (railingwidthL + 0.01)]}
                rotation={[-Math.PI, 0, -Math.PI]}
              >
                <mesh
                  material-color={'#293133'}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
            );
          }
        }
        if (props.form == 'u') {
          for (let i = 0; i < amountU; i++) {
            if (props.qlineinfill == 'plates') {
              infillmesh.push(
                <group
                  comment="Glass"
                  position={[
                    0 + railingwidthU * 5 + i * (railingwidthU * 10) + fasciapostadjust * 10,
                    -0.08 - movetheglass,
                    railingwidthL * 10 * amountL + fasciapostadjust * 20,
                  ]}
                  scale={[10, 10, 10 * (railingwidthU + 0.01)]}
                  rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
                >
                  <mesh
                    material-color={'#293133'}
                    geometry={nodes.GlassJ1.geometry}
                    position={[0, 0.6, 0]}
                    rotation={[0, 0, 0]}
                  />
                </group>,
              );
            }
          }
        }
        //Platecorners for l and u
        if (
          (props.form == 'u' || props.form == 'l') &&
          (props.montageart != 'top' || (props.montageart == 'top' && props.postshape == '60x30')) &&
          props.qlineinfill == 'plates'
        ) {
          infillmesh.push(
            <group
              comment="Glass"
              position={[0, -0.08 - movetheglass, 1.1]}
              scale={[10, 10, 2]}
              rotation={[-Math.PI, 0, -Math.PI]}
            >
              <mesh
                material-color={'#293133'}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
            <group
              comment="Glass"
              position={[1.1, -0.08 - movetheglass, 0]}
              scale={[10, 10, 2]}
              rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
            >
              <mesh
                material-color={'#293133'}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>,
          );

          if (props.form == 'u') {
            infillmesh.push(
              <group
                comment="Glass"
                position={[0, -0.08 - movetheglass, props.len2 / 100 - 1.1]}
                scale={[10, 10, 2]}
                rotation={[-Math.PI, 0, -Math.PI]}
              >
                <mesh
                  material-color={'#293133'}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
              <group
                comment="Glass"
                position={[1.1, -0.08 - movetheglass, props.len2 / 100]}
                scale={[10, 10, 2]}
                rotation={[-Math.PI, Math.PI / 2, -Math.PI]}
              >
                <mesh
                  material-color={'#293133'}
                  geometry={nodes.GlassJ1.geometry}
                  position={[0, 0.6, 0]}
                  rotation={[0, 0, 0]}
                />
              </group>,
            );
          }
        }
      }
    }

    return infillmesh;
  }

  const renderthirdmodelcornerbrackets = () => {
    //eslint-disable-next-line
    const { nodes, materials } = useGLTF('/QLinecorners.gltf');
    let maparray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return (
      <group ref={groupcorner} {...props} dispose={null} scale={[10, 10, 10]}>
        {(props.qlineinfill == 'glass' || props.qlineinfill == 'plates') && props.form != 'i' && (
          <>
            <group position={[0 - 0.015, 0.15, 0 - 0.015]}>
              <mesh
                visible={props.clampshape != 'round' ? true : false}
                material={nodes.Mod4290c1.material}
                geometry={nodes.Mod4290c1.geometry}
              />
              <mesh
                material={nodes.Mod4290c2.material}
                geometry={nodes.Mod4290c2.geometry}
                material-color={colorr}
                position={[0, 0, 0]}
                rotation={[Math.PI / 2, 0, -Math.PI / 4]}
                visible={props.clampshape != 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod4290screw1.material}
                geometry={nodes.Mod4290screw1.geometry}
                material-color={colorr}
                position={[0.04, 0.01, 0.04]}
                rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                visible={props.clampshape != 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod4290screw2.material}
                material-color={colorr}
                geometry={nodes.Mod4290screw2.geometry}
                position={[0.04, 0.03, 0.04]}
                rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                visible={props.clampshape != 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod4290gasket1.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket1.geometry}
                position={[0.06, 0.02, 0.01]}
                visible={props.clampshape != 'round' ? true : false}
                rotation={[0, -1.57, 0]}
              />
              <mesh
                material={nodes.Mod4290gasket2.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket2.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0.06, 0.02, 0.03]}
                rotation={[0, -1.57, 0]}
              />
              <mesh
                material={nodes.Mod4290gasket3.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket3.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0, 0.02, 0.06]}
                rotation={[-Math.PI, 0, -Math.PI]}
              />
              <mesh
                material={nodes.Mod4290gasket4.material}
                visible={props.clampshape != 'round' ? true : false}
                material-color={colorr}
                geometry={nodes.Mod4290gasket4.geometry}
                position={[0.02, 0.02, 0.06]}
                rotation={[-Math.PI, 0, -Math.PI]}
              />
              <mesh
                material={nodes.Mod2890c1.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890c1.geometry}
                position={[0, 0.02, 0.07]}
                rotation={[Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={nodes.Mod2890c2.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890c2.geometry}
                position={[0, 0.02, 0.07]}
                rotation={[Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={nodes.Mod2890screw1.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890screw1.geometry}
                position={[0.05, 0.01, 0.05]}
                rotation={[0, -Math.PI / 4, -1.89]}
              />
              <mesh
                material={nodes.Mod2890screw2.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890screw2.geometry}
                position={[0.05, 0.03, 0.05]}
                rotation={[0, -Math.PI / 4, -1.22]}
              />
              <mesh
                material={nodes.Mod2890gasket1.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890gasket1.geometry}
                position={[0.05, 0.04, 0.03]}
                rotation={[-Math.PI / 2, 0, Math.PI / 2]}
              />
              <mesh
                material={nodes.Mod2890gasket2.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890gasket2.geometry}
                position={[0.06, 0.04, 0.06]}
                rotation={[-Math.PI / 2, 0, Math.PI / 2]}
              />
              <mesh
                material={nodes.Mod2890gasket3.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890gasket3.geometry}
                position={[-0.01, 0.04, 0.05]}
                rotation={[-Math.PI / 2, 0, 0]}
              />
              <mesh
                material={nodes.Mod2890gasket4.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890gasket4.geometry}
                position={[0.01, 0.04, 0.06]}
                rotation={[-Math.PI / 2, 0, 0]}
              />
            </group>
            <group position={[0 - 0.015, 0.85, 0 - 0.015]}>
              <mesh
                material={nodes.Mod4290c1.material}
                geometry={nodes.Mod4290c1.geometry}
                visible={props.clampshape != 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod4290c2.material}
                geometry={nodes.Mod4290c2.geometry}
                visible={props.clampshape != 'round' ? true : false}
                material-color={colorr}
                position={[0, 0, 0]}
                rotation={[Math.PI / 2, 0, -Math.PI / 4]}
              />
              <mesh
                material={nodes.Mod4290screw1.material}
                geometry={nodes.Mod4290screw1.geometry}
                visible={props.clampshape != 'round' ? true : false}
                material-color={colorr}
                position={[0.04, 0.01, 0.04]}
                rotation={[0, -Math.PI / 4, -Math.PI / 2]}
              />
              <mesh
                material={nodes.Mod4290screw2.material}
                material-color={colorr}
                geometry={nodes.Mod4290screw2.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0.04, 0.03, 0.04]}
                rotation={[0, -Math.PI / 4, -Math.PI / 2]}
              />
              <mesh
                material={nodes.Mod4290gasket1.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket1.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0.06, 0.02, 0.01]}
                rotation={[0, -1.57, 0]}
              />
              <mesh
                material={nodes.Mod4290gasket2.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket2.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0.06, 0.02, 0.03]}
                rotation={[0, -1.57, 0]}
              />
              <mesh
                material={nodes.Mod4290gasket3.material}
                material-color={colorr}
                geometry={nodes.Mod4290gasket3.geometry}
                visible={props.clampshape != 'round' ? true : false}
                position={[0, 0.02, 0.06]}
                rotation={[-Math.PI, 0, -Math.PI]}
              />
              <mesh
                material={nodes.Mod4290gasket4.material}
                material-color={colorr}
                visible={props.clampshape != 'round' ? true : false}
                geometry={nodes.Mod4290gasket4.geometry}
                position={[0.02, 0.02, 0.06]}
                rotation={[-Math.PI, 0, -Math.PI]}
              />
              <mesh
                material={nodes.Mod2890c1.material}
                material-color={colorr}
                geometry={nodes.Mod2890c1.geometry}
                visible={props.clampshape == 'round' ? true : false}
                position={[0, 0.02, 0.07]}
                rotation={[Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={nodes.Mod2890c2.material}
                material-color={colorr}
                geometry={nodes.Mod2890c2.geometry}
                position={[0, 0.02, 0.07]}
                visible={props.clampshape == 'round' ? true : false}
                rotation={[Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={nodes.Mod2890screw1.material}
                material-color={colorr}
                geometry={nodes.Mod2890screw1.geometry}
                position={[0.05, 0.01, 0.05]}
                rotation={[0, -Math.PI / 4, -1.89]}
                visible={props.clampshape == 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod2890screw2.material}
                material-color={colorr}
                geometry={nodes.Mod2890screw2.geometry}
                position={[0.05, 0.03, 0.05]}
                rotation={[0, -Math.PI / 4, -1.22]}
                visible={props.clampshape == 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod2890gasket1.material}
                material-color={colorr}
                geometry={nodes.Mod2890gasket1.geometry}
                position={[0.05, 0.04, 0.03]}
                rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                visible={props.clampshape == 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod2890gasket2.material}
                material-color={colorr}
                geometry={nodes.Mod2890gasket2.geometry}
                position={[0.06, 0.04, 0.06]}
                rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                visible={props.clampshape == 'round' ? true : false}
              />
              <mesh
                material={nodes.Mod2890gasket3.material}
                material-color={colorr}
                geometry={nodes.Mod2890gasket3.geometry}
                visible={props.clampshape == 'round' ? true : false}
                position={[-0.01, 0.04, 0.05]}
                rotation={[-Math.PI / 2, 0, 0]}
              />
              <mesh
                material={nodes.Mod2890gasket4.material}
                material-color={colorr}
                visible={props.clampshape == 'round' ? true : false}
                geometry={nodes.Mod2890gasket4.geometry}
                position={[0.01, 0.04, 0.06]}
                rotation={[-Math.PI / 2, 0, 0]}
              />
            </group>
            {props.form == 'u' && (
              <>
                <group position={[0 - 0.015, 0.15, 0 + 0.02 + props.len2 / 1000]} rotation={[0, Math.PI / 2, 0]}>
                  <mesh
                    material={nodes.Mod4290c1.material}
                    geometry={nodes.Mod4290c1.geometry}
                    visible={props.clampshape != 'round' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290c2.material}
                    geometry={nodes.Mod4290c2.geometry}
                    material-color={colorr}
                    position={[0, 0, 0]}
                    rotation={[Math.PI / 2, 0, -Math.PI / 4]}
                    visible={props.clampshape == 'square' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290screw1.material}
                    geometry={nodes.Mod4290screw1.geometry}
                    material-color={colorr}
                    position={[0.04, 0.01, 0.04]}
                    rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                    visible={props.clampshape == 'square' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290screw2.material}
                    material-color={colorr}
                    geometry={nodes.Mod4290screw2.geometry}
                    position={[0.04, 0.03, 0.04]}
                    rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                    visible={props.clampshape == 'square' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290gasket1.material}
                    material-color={colorr}
                    geometry={nodes.Mod4290gasket1.geometry}
                    position={[0.06, 0.02, 0.01]}
                    rotation={[0, -1.57, 0]}
                    visible={props.clampshape == 'square' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290gasket2.material}
                    material-color={colorr}
                    geometry={nodes.Mod4290gasket2.geometry}
                    position={[0.06, 0.02, 0.03]}
                    rotation={[0, -1.57, 0]}
                    visible={props.clampshape == 'square' ? true : false}
                  />
                  <mesh
                    material={nodes.Mod4290gasket3.material}
                    material-color={colorr}
                    geometry={nodes.Mod4290gasket3.geometry}
                    position={[0, 0.02, 0.06]}
                    visible={props.clampshape == 'square' ? true : false}
                    rotation={[-Math.PI, 0, -Math.PI]}
                  />
                  <mesh
                    material={nodes.Mod4290gasket4.material}
                    material-color={colorr}
                    geometry={nodes.Mod4290gasket4.geometry}
                    position={[0.02, 0.02, 0.06]}
                    visible={props.clampshape == 'square' ? true : false}
                    rotation={[-Math.PI, 0, -Math.PI]}
                  />
                  <mesh
                    material={nodes.Mod2890c1.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890c1.geometry}
                    position={[0, 0.02, 0.07]}
                    rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890c2.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890c2.geometry}
                    position={[0, 0.02, 0.07]}
                    rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890screw1.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890screw1.geometry}
                    position={[0.05, 0.01, 0.05]}
                    rotation={[0, -Math.PI / 4, -1.89]}
                  />
                  <mesh
                    material={nodes.Mod2890screw2.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890screw2.geometry}
                    position={[0.05, 0.03, 0.05]}
                    rotation={[0, -Math.PI / 4, -1.22]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket1.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890gasket1.geometry}
                    position={[0.05, 0.04, 0.03]}
                    rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket2.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890gasket2.geometry}
                    position={[0.06, 0.04, 0.06]}
                    rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket3.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890gasket3.geometry}
                    position={[-0.01, 0.04, 0.05]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket4.material}
                    material-color={colorr}
                    visible={props.clampshape != 'square' ? true : false}
                    geometry={nodes.Mod2890gasket4.geometry}
                    position={[0.01, 0.04, 0.06]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                </group>
                <group position={[0 - 0.015, 0.85, 0 + 0.02 + props.len2 / 1000]} rotation={[0, Math.PI / 2, 0]}>
                  <mesh
                    material={nodes.Mod4290c1.material}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290c1.geometry}
                  />
                  <mesh
                    material={nodes.Mod4290c2.material}
                    geometry={nodes.Mod4290c2.geometry}
                    visible={props.clampshape != 'round' ? true : false}
                    material-color={colorr}
                    position={[0, 0, 0]}
                    rotation={[Math.PI / 2, 0, -Math.PI / 4]}
                  />
                  <mesh
                    material={nodes.Mod4290screw1.material}
                    geometry={nodes.Mod4290screw1.geometry}
                    visible={props.clampshape != 'round' ? true : false}
                    material-color={colorr}
                    position={[0.04, 0.01, 0.04]}
                    rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod4290screw2.material}
                    material-color={colorr}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290screw2.geometry}
                    position={[0.04, 0.03, 0.04]}
                    rotation={[0, -Math.PI / 4, -Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod4290gasket1.material}
                    material-color={colorr}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290gasket1.geometry}
                    position={[0.06, 0.02, 0.01]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    material={nodes.Mod4290gasket2.material}
                    material-color={colorr}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290gasket2.geometry}
                    position={[0.06, 0.02, 0.03]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    material={nodes.Mod4290gasket3.material}
                    material-color={colorr}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290gasket3.geometry}
                    position={[0, 0.02, 0.06]}
                    rotation={[-Math.PI, 0, -Math.PI]}
                  />
                  <mesh
                    material={nodes.Mod4290gasket4.material}
                    material-color={colorr}
                    visible={props.clampshape != 'round' ? true : false}
                    geometry={nodes.Mod4290gasket4.geometry}
                    position={[0.02, 0.02, 0.06]}
                    rotation={[-Math.PI, 0, -Math.PI]}
                  />
                  <mesh
                    material={nodes.Mod2890c1.material}
                    material-color={colorr}
                    visible={props.clampshape == 'round' ? true : false}
                    geometry={nodes.Mod2890c1.geometry}
                    position={[0, 0.02, 0.07]}
                    rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890c2.material}
                    material-color={colorr}
                    visible={props.clampshape == 'round' ? true : false}
                    geometry={nodes.Mod2890c2.geometry}
                    position={[0, 0.02, 0.07]}
                    rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890screw1.material}
                    material-color={colorr}
                    visible={props.clampshape == 'round' ? true : false}
                    geometry={nodes.Mod2890screw1.geometry}
                    position={[0.05, 0.01, 0.05]}
                    rotation={[0, -Math.PI / 4, -1.89]}
                  />
                  <mesh
                    material={nodes.Mod2890screw2.material}
                    material-color={colorr}
                    geometry={nodes.Mod2890screw2.geometry}
                    visible={props.clampshape == 'round' ? true : false}
                    position={[0.05, 0.03, 0.05]}
                    rotation={[0, -Math.PI / 4, -1.22]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket1.material}
                    material-color={colorr}
                    geometry={nodes.Mod2890gasket1.geometry}
                    visible={props.clampshape == 'round' ? true : false}
                    position={[0.05, 0.04, 0.03]}
                    rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket2.material}
                    visible={props.clampshape == 'round' ? true : false}
                    material-color={colorr}
                    geometry={nodes.Mod2890gasket2.geometry}
                    position={[0.06, 0.04, 0.06]}
                    rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket3.material}
                    material-color={colorr}
                    visible={props.clampshape == 'round' ? true : false}
                    geometry={nodes.Mod2890gasket3.geometry}
                    position={[-0.01, 0.04, 0.05]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    material={nodes.Mod2890gasket4.material}
                    visible={props.clampshape == 'round' ? true : false}
                    material-color={colorr}
                    geometry={nodes.Mod2890gasket4.geometry}
                    position={[0.01, 0.04, 0.06]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                </group>
              </>
            )}
          </>
        )}
        {props.qlineinfill == 'verticalbars' && props.form != 'i' && (
          <>
            {maparray.map((item, index) => {
              let scalorfactor = 0.095;
              {
                props.montageart != 'top' && (scalorfactor = 0.1);
              }
              return (
                <>
                  <group
                    position={[0 - 0.027, 0.979 - index * scalorfactor, 0 - 0.027]}
                    rotation={[0, 0, 0]}
                    visible={true}
                  >
                    <mesh
                      material={nodes.Mod1312c1.material}
                      geometry={nodes.Mod1312c1.geometry}
                      position={[0, 0.01, 0]}
                      rotation={[0, 0, -Math.PI]}
                    />
                    <mesh
                      material={nodes.Mod1312c2.material}
                      geometry={nodes.Mod1312c2.geometry}
                      position={[0, 0.01, 0]}
                      rotation={[-Math.PI, 1.57, 0]}
                    />
                  </group>
                  {props.form == 'u' && (
                    <group
                      position={[0 - 0.027, 0.979 - index * scalorfactor, 0 + 0.027 + props.len2 / 1000]}
                      rotation={[0, Math.PI / 2, 0]}
                      visible={true}
                    >
                      <mesh
                        material={nodes.Mod1312c1.material}
                        geometry={nodes.Mod1312c1.geometry}
                        position={[0, 0.01, 0]}
                        rotation={[0, 0, -Math.PI]}
                      />
                      <mesh
                        material={nodes.Mod1312c2.material}
                        geometry={nodes.Mod1312c2.geometry}
                        position={[0, 0.01, 0]}
                        rotation={[-Math.PI, 1.57, 0]}
                      />
                    </group>
                  )}
                </>
              );
            })}
          </>
        )}
      </group>
    );
  };

  function renderklammer(rundodereckig, phaseinput1, phaseinput2) {
    let adjustklammer1X = 0;
    let adjustklammer1Y = 0;
    let visible1 = true;
    let visible2 = true;
    let adjustklammer2X = 0.049;
    let adjustklammer2Y = 0.04;
    let rotateklammer1 = [0, 0, 0];
    let rotateklammer2 = [0, Math.PI / 2, 0];

    let phase = 4;
    phase = phaseinput1;

    if (props.clampshape == 'square') {
      if (phaseinput1 == 1) {
        rotateklammer1 = [0, Math.PI, 0];
        adjustklammer1Y = 0.09;
        adjustklammer1X = 0;
      }
      if (phaseinput2 == 1) {
        adjustklammer2X = 0;
        adjustklammer2Y = 0 - 0.009;
        rotateklammer2 = [0, 0, 0];
      }
      if (phaseinput1 == 2) {
        rotateklammer1 = [0, (3 * Math.PI) / 2, 0];
        adjustklammer1X = -0.049;
        adjustklammer1Y = 0.04;
      }
      if (phaseinput2 == 2) {
        rotateklammer2 = [0, Math.PI, 0];
        adjustklammer2Y = 0.09;
        adjustklammer2X = 0;
      }
      if (phaseinput1 == 3) {
        adjustklammer1X = 0.049;
        adjustklammer1Y = 0.04;
        rotateklammer1 = [0, Math.PI / 2, 0];
      }
      if (phaseinput2 == 3) {
        rotateklammer2 = [0, Math.PI / 2, 0];
        rotateklammer2 = [0, (3 * Math.PI) / 2, 0];
        adjustklammer2X = -0.049;
      }
      return (
        <>
          <group
            position={[0 - adjustklammer1X, 0.87, -0.04 + adjustklammer1Y]}
            visible={visible1}
            rotation={rotateklammer1}
            comment="KlammerEckigOben"
          >
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatScrew1'].geometry}
              position={[0.01, 0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatScrew2'].geometry}
              position={[0.01, -0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatHousing1'].geometry}
              position={[-0.01, 0, 0]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatHousing2'].geometry}
              position={[0.01, 0, 0]}
            />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket1'].geometry} position={[0, 0, 0.01]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket2'].geometry} position={[0, 0, 0]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket3'].geometry} position={[0.01, 0, 0]} />
          </group>
          <group
            position={[0 - adjustklammer1X, 0.17, -0.04 + adjustklammer1Y]}
            visible={visible1}
            rotation={rotateklammer1}
            comment="KlammerEckigUnten"
          >
            <group position={[0.01, 0, 0]}>
              <mesh material={nodes['4200RoundHousing1_1'].material} geometry={nodes['4200RoundHousing1_1'].geometry} />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['4200RoundHousing1-AluAltPhysicalEngine'].geometry}
              />
            </group>
            <group position={[-0.01, 0, 0]} rotation={[0, 0, -Math.PI]}>
              <mesh material={nodes['4200RoundHousing2_1'].material} geometry={nodes['4200RoundHousing2_1'].geometry} />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['4200RoundHousing2-AluAltPhysicalEngine'].geometry}
              />
            </group>
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket1'].geometry} position={[0, 0, 0.01]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket2'].geometry} position={[0, 0, 0]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket3'].geometry} position={[0.01, 0, 0]} />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundScrew1'].geometry}
              position={[0.01, 0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundScrew1_1'].geometry}
              position={[0.01, -0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
          </group>
          <group
            visible={visible2}
            position={[0 - adjustklammer2X, 0.87, -0.04 + adjustklammer2Y]}
            rotation={rotateklammer2}
            comment="KlammerEckigOben"
          >
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatScrew1'].geometry}
              position={[0.01, 0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatScrew2'].geometry}
              position={[0.01, -0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatHousing1'].geometry}
              position={[-0.01, 0, 0]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200FlatHousing2'].geometry}
              position={[0.01, 0, 0]}
            />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket1'].geometry} position={[0, 0, 0.01]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket2'].geometry} position={[0, 0, 0]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket3'].geometry} position={[0.01, 0, 0]} />
          </group>
          <group
            visible={visible2}
            position={[0 - adjustklammer2X, 0.17, -0.04 + adjustklammer2Y]}
            rotation={rotateklammer2}
            comment="KlammerEckigUnten"
          >
            <group position={[0.01, 0, 0]}>
              <mesh material={nodes['4200RoundHousing1_1'].material} geometry={nodes['4200RoundHousing1_1'].geometry} />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['4200RoundHousing1-AluAltPhysicalEngine'].geometry}
              />
            </group>
            <group position={[-0.01, 0, 0]} rotation={[0, 0, -Math.PI]}>
              <mesh material={nodes['4200RoundHousing2_1'].material} geometry={nodes['4200RoundHousing2_1'].geometry} />
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['4200RoundHousing2-AluAltPhysicalEngine'].geometry}
              />
            </group>
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket1'].geometry} position={[0, 0, 0.01]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket2'].geometry} position={[0, 0, 0]} />
            <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket3'].geometry} position={[0.01, 0, 0]} />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundScrew1'].geometry}
              position={[0.01, 0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundScrew1_1'].geometry}
              position={[0.01, -0.01, 0.01]}
              rotation={[0, 0, -Math.PI / 2]}
            />
          </group>
        </>
      );
    }

    if (props.clampshape == 'round') {
      adjustklammer1X = 0;
      adjustklammer1Y = 0;

      adjustklammer2X = 0.049 - 0.026;
      adjustklammer2Y = 0.04;
      if (phaseinput1 == 1) {
        rotateklammer1 = [0, Math.PI, 0];
        adjustklammer1Y = 0.09 - 0.026;
        adjustklammer1X = 0;
      }
      if (phaseinput2 == 1) {
        adjustklammer2X = 0;
        adjustklammer2Y = 0 + 0.017;
        rotateklammer2 = [0, 0, 0];
      }
      if (phaseinput1 == 2) {
        rotateklammer1 = [0, (3 * Math.PI) / 2, 0];
        adjustklammer1X = -0.049 + 0.026;
        adjustklammer1Y = 0.04;
      }
      if (phaseinput2 == 2) {
        rotateklammer2 = [0, Math.PI, 0];
        adjustklammer2Y = 0.09 - 0.026;
        adjustklammer2X = 0;
      }
      if (phaseinput1 == 3) {
        adjustklammer1X = 0.049 - 0.026;
        adjustklammer1Y = 0.04;
        rotateklammer1 = [0, Math.PI / 2, 0];
      }
      if (phaseinput2 == 3) {
        rotateklammer2 = [0, Math.PI / 2, 0];
        rotateklammer2 = [0, (3 * Math.PI) / 2, 0];
        adjustklammer2X = -0.049 + 0.026;
      }

      return (
        <>
          <group
            position={[0 - adjustklammer1X, 0.87, -0.04 + adjustklammer1Y]}
            visible={visible1}
            rotation={rotateklammer1}
            comment="KlammerRund1"
          >
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing1-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing1-Dichtung'].geometry} />
            </group>
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing2-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing2-Dichtung'].geometry} />
            </group>
            <mesh
              material={materials.Dichtung}
              geometry={nodes['2800FlatGasket1'].geometry}
              position={[0, 0, -0.02]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew1'].geometry}
              position={[-0.01, -0.01, -0.01]}
              rotation={[-0.01, 0.1, 1.82]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew2'].geometry}
              position={[-0.01, 0.01, -0.01]}
              rotation={[0.01, 0.1, 1.33]}
            />
          </group>
          <group
            position={[0 - adjustklammer1X, 0.17, -0.04 + adjustklammer1Y]}
            visible={visible1}
            rotation={rotateklammer1}
            comment="KlammerRund"
          >
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing1-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing1-Dichtung'].geometry} />
            </group>
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing2-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing2-Dichtung'].geometry} />
            </group>
            <mesh
              material={materials.Dichtung}
              geometry={nodes['2800FlatGasket1'].geometry}
              position={[0, 0, -0.02]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew1'].geometry}
              position={[-0.01, -0.01, -0.01]}
              rotation={[-0.01, 0.1, 1.82]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew2'].geometry}
              position={[-0.01, 0.01, -0.01]}
              rotation={[0.01, 0.1, 1.33]}
            />
          </group>
          <group
            visible={visible2}
            position={[0 - adjustklammer2X, 0.87, -0.04 + adjustklammer2Y]}
            rotation={rotateklammer2}
            comment="KlammerRund2"
          >
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing1-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing1-Dichtung'].geometry} />
            </group>
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing2-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing2-Dichtung'].geometry} />
            </group>
            <mesh
              material={materials.Dichtung}
              geometry={nodes['2800FlatGasket1'].geometry}
              position={[0, 0, -0.02]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew1'].geometry}
              position={[-0.01, -0.01, -0.01]}
              rotation={[-0.01, 0.1, 1.82]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew2'].geometry}
              position={[-0.01, 0.01, -0.01]}
              rotation={[0.01, 0.1, 1.33]}
            />
          </group>
          <group
            visible={visible2}
            position={[0 - adjustklammer2X, 0.17, -0.04 + adjustklammer2Y]}
            rotation={rotateklammer2}
            comment="KlammerRund1"
          >
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing1-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing1-Dichtung'].geometry} />
            </group>
            <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                material={materials.AluAltPhysicalEngine}
                geometry={nodes['2800FlatHousing2-AluAltPhysicalEngine'].geometry}
              />
              <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing2-Dichtung'].geometry} />
            </group>
            <mesh
              material={materials.Dichtung}
              geometry={nodes['2800FlatGasket1'].geometry}
              position={[0, 0, -0.02]}
              rotation={[0, 0, -Math.PI]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew1'].geometry}
              position={[-0.01, -0.01, -0.01]}
              rotation={[-0.01, 0.1, 1.82]}
            />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatScrew2'].geometry}
              position={[-0.01, 0.01, -0.01]}
              rotation={[0.01, 0.1, 1.33]}
            />
          </group>
        </>
      );
    }
  }

  function renderpostsystem() {
    return (
      <group ref={group} {...props} dispose={null} scale={[10, 10, 10]}>
        {props.postshape == '40x40' && pfosten40x40()}
        {props.postshape == '60x30' && pfosten30x60()}
        {props.postshape == 'round' && pfostenrund()}
        <group position={[0, 0.87, -0.02]} rotation={[0, 0, -Math.PI]} visible={false} comment="KlammerRund1">
          <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatHousing1-AluAltPhysicalEngine'].geometry}
            />
            <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing1-Dichtung'].geometry} />
          </group>
          <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800FlatHousing2-AluAltPhysicalEngine'].geometry}
            />
            <mesh material={materials.Dichtung} geometry={nodes['2800FlatHousing2-Dichtung'].geometry} />
          </group>
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2800FlatGasket1'].geometry}
            position={[0, 0, -0.02]}
            rotation={[0, 0, -Math.PI]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2800FlatScrew1'].geometry}
            position={[-0.01, -0.01, -0.01]}
            rotation={[-0.01, 0.1, 1.82]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2800FlatScrew2'].geometry}
            position={[-0.01, 0.01, -0.01]}
            rotation={[0.01, 0.1, 1.33]}
          />
        </group>
        <group
          position={[0, 0.87, -0.02]}
          rotation={[-Math.PI / 2, 0, -Math.PI]}
          comment="KlammerRund2"
          visible={false}
        >
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500FlatHousing1'].geometry}
            position={[0.6, 1.88, 0.01]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500FlatHousing2'].geometry}
            position={[0.6, 1.88, 0.01]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500FlatGasket1'].geometry}
            position={[0, -0.02, 0]}
            rotation={[-Math.PI / 2, 0, -Math.PI]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500FlatGasket2'].geometry}
            position={[-0.03, -0.02, 0.01]}
            rotation={[0, 0, 0]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500FlatGasket3'].geometry}
            position={[-0.01, -0.02, 0.01]}
            rotation={[0, 0, 0]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500FlatScrew1'].geometry}
            position={[-0.01, -0.01, 0.01]}
            rotation={[-Math.PI / 2, 0, Math.PI / 2]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500FlatScrew2'].geometry}
            position={[-0.01, -0.01, -0.01]}
            rotation={[-Math.PI / 2, 0, Math.PI / 2]}
          />
        </group>
        <group position={[0, 0.87, -0.04]} comment="KlammerEckig" visible={false}>
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200FlatScrew1'].geometry}
            position={[0.01, 0.01, 0.01]}
            rotation={[0, 0, -Math.PI / 2]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200FlatScrew2'].geometry}
            position={[0.01, -0.01, 0.01]}
            rotation={[0, 0, -Math.PI / 2]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200FlatHousing1'].geometry}
            position={[-0.01, 0, 0]}
            rotation={[0, 0, -Math.PI]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200FlatHousing2'].geometry}
            position={[0.01, 0, 0]}
          />
          <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket1'].geometry} position={[0, 0, 0.01]} />
          <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket2'].geometry} position={[0, 0, 0]} />
          <mesh material={materials.Dichtung} geometry={nodes['4200FlatGasket3'].geometry} position={[0.01, 0, 0]} />
        </group>
        <group position={[0, 0.17, -0.02]} rotation={[-Math.PI / 2, 0, -Math.PI]} visible={false}>
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500RoundHousing1'].geometry}
            position={[0.6, 1.87, 0.01]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500RoundHousing2'].geometry}
            position={[0.6, 1.87, 0.01]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500RoundGasket1'].geometry}
            position={[0, -0.02, 0]}
            rotation={[-Math.PI / 2, 0, -Math.PI]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500RoundGasket2'].geometry}
            position={[-0.01, -0.03, 0.01]}
            rotation={[0, 0, 0]}
          />
          <mesh
            material={materials.Dichtung}
            geometry={nodes['2500RoundGasket3'].geometry}
            position={[-0.03, -0.03, 0.01]}
            rotation={[0, 0, 0]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500RoundScrew1'].geometry}
            position={[-0.01, -0.01, 0.01]}
            rotation={[-Math.PI / 2, 0, Math.PI / 2]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2500RoundScrew2'].geometry}
            position={[-0.01, -0.01, -0.01]}
            rotation={[-Math.PI / 2, 0, Math.PI / 2]}
          />
        </group>
        <group position={[0, 0.17, -0.02]} visible={false}>
          <group position={[0, 0.01, -0.01]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800RoundHousing1-AluAltPhysicalEngine'].geometry}
            />
            <mesh material={materials.Dichtung} geometry={nodes['2800RoundHousing1-Dichtung'].geometry} />
          </group>
          <group position={[0, 0.01, -0.01]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['2800RoundHousing2-AluAltPhysicalEngine'].geometry}
            />
            <mesh material={materials.Dichtung} geometry={nodes['2800RoundHousing2-Dichtung'].geometry} />
          </group>
          <mesh material={materials.Dichtung} geometry={nodes['2800RoundGasket1'].geometry} position={[0, 0, -0.02]} />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2800RoundScrew1'].geometry}
            position={[0.01, 0.01, -0.01]}
            rotation={[0.01, -0.1, -1.33]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['2800RoundScrew2'].geometry}
            position={[0.01, -0.01, -0.01]}
            rotation={[-0.01, -0.1, -1.81]}
          />
        </group>
        <group position={[0, 0.17, -0.05]} visible={false}>
          <group position={[0.01, 0, 0]}>
            <mesh material={nodes['4200RoundHousing1_1'].material} geometry={nodes['4200RoundHousing1_1'].geometry} />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundHousing1-AluAltPhysicalEngine'].geometry}
            />
          </group>
          <group position={[-0.01, 0, 0]} rotation={[0, 0, -Math.PI]}>
            <mesh material={nodes['4200RoundHousing2_1'].material} geometry={nodes['4200RoundHousing2_1'].geometry} />
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes['4200RoundHousing2-AluAltPhysicalEngine'].geometry}
            />
          </group>
          <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket1'].geometry} position={[0, 0, 0.01]} />
          <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket2'].geometry} position={[0, 0, 0]} />
          <mesh material={materials.Dichtung} geometry={nodes['4200RoundGasket3'].geometry} position={[0.01, 0, 0]} />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200RoundScrew1'].geometry}
            position={[0.01, 0.01, 0.01]}
            rotation={[0, 0, -Math.PI / 2]}
          />
          <mesh
            material={materials.AluAltPhysicalEngine}
            geometry={nodes['4200RoundScrew1_1'].geometry}
            position={[0.01, -0.01, 0.01]}
            rotation={[0, 0, -Math.PI / 2]}
          />
        </group>
        <mesh
          visible={false}
          material={materials.AluAltPhysicalEngine}
          geometry={nodes['180Flat'].geometry}
          position={[0, 1, 0]}
        />
        <mesh
          visible={false}
          material={materials.AluAltPhysicalEngine}
          geometry={nodes['180Round'].geometry}
          position={[0, 1, 0]}
          rotation={[0, 0, 0]}
        />
        <mesh
          visible={false}
          material={materials.AluAltPhysicalEngine}
          geometry={nodes['90Flat'].geometry}
          position={[0, 1, 0]}
        />
        <mesh
          visible={false}
          material={materials.AluAltPhysicalEngine}
          geometry={nodes['90Round'].geometry}
          position={[0, 1, 0]}
          comment="PfostenCornerPlatteUnterHandrail"
        />
      </group>
    );
  }
  function renderhandrail() {
    let len1 = parseInt(props.len1);
    let len2 = parseInt(props.len2);
    let len3 = parseInt(props.len3);
    let adjustvaluelen = 0;
    let railfasciaadjust = 0;
    let iAdjust = 0;
    let mountdifferentadjust = len2 / 100;
    let adjustLshape = 0;
    let moverail = 0;
    if ((props.montageart != 'top' || props.postshape == '60x30') && (props.form == 'l' || props.form == 'u')) {
      railfasciaadjust = 2.6;
      railfasciaadjust = 0;
      adjustvaluelen = 250;
      adjustvaluelen = 0;
    }

    if ((props.montageart != 'top' || props.postshape == '60x30') && props.form == 'i') {
      iAdjust = 2.5;
      railfasciaadjust = 0;
    }

    if (letsmountdifferently) {
      moverail = 1.15;
      if (props.postshape == 'round') {
        railfasciaadjust = 1.15;
        adjustvaluelen = -0.75;
        mountdifferentadjust = (len2 + adjustvaluelen) / 100;
        moverail = 0.375;
      } else {
        railfasciaadjust = 1.15;
        if (props.form == 'l') {
          adjustLshape = 1.15;
        }
        adjustvaluelen = -115;
        if (props.form == 'i' && props.handlaufmat == 'square') {
          railfasciaadjust = 0;
          moverail = 0.65;
          adjustvaluelen = 0;
        }
      }
    }

    let handrailCablesI = 0;
    let handrailCablesU = 0;

    if (props.qlineinfill == 'cables' && props.form != 'i') {
      {
        props.handlaufmat == 'round' && ((handrailCablesI = 0.4), (handrailCablesU = 0.45));
      }
      {
        props.handlaufmat == 'square' && (handrailCablesU = 0.2);
      }
    }

    return (
      <>
        {props.handlaufmat == 'round' && (
          <>
            {
              <>
                <mesh
                  comment="Handlauf-Rund"
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrail.geometry}
                  position={[len1 / 100 + railfasciaadjust + iAdjust, 11, 0]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  scale={[10, len1 / 100, 10]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrailCorner2.geometry}
                  scale={[10, 10, 10]}
                  position={[len1 / 100 - 4.3 + railfasciaadjust + iAdjust - handrailCablesI, 11, 0]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                />
                {props.form == 'i' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner1.geometry}
                    position={[4.5 + railfasciaadjust + iAdjust, 11, 0]}
                    scale={[10, 9.999, 9.999]}
                    rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  />
                )}
              </>
            }
            {(props.form == 'l' || props.form == 'u') && (
              <>
                <group
                  position={[0, 11, 0]}
                  scale={[10, 10, 10]}
                  rotation={[0, -Math.PI / 2, 0]}
                  comment="rundHandlaufCorner"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner1.geometry}
                    position={[0, 0, 0.02]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner2.geometry}
                    position={[0, 0, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  />
                </group>
                <mesh
                  comment="Handlauf-Rund"
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrail.geometry}
                  position={[0, 11, (len2 - adjustvaluelen) / 100 - adjustLshape / 2]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={[10, (len2 - adjustvaluelen) / 100 - adjustLshape, 10]}
                />

                {props.form == 'l' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner2.geometry}
                    position={[0, 11, (len2 - adjustvaluelen * 2) / 100 - 4.2 - moverail - adjustLshape]}
                    scale={[10, 10, 10]}
                    rotation={[0, -Math.PI / 2, -Math.PI / 2]}
                  />
                )}
              </>
            )}
            {props.form == 'u' && (
              <>
                <group
                  position={[0, 11, len2 / 100 + moverail]}
                  scale={[10, 10, 10]}
                  rotation={[0, 0, 0]}
                  comment="rundHandlaufCorner"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner1.geometry}
                    position={[0, 0, 0.02]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes.RoundHandrailCorner2.geometry}
                    position={[0, 0, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  />
                </group>
                <mesh
                  comment="Handlauf-Rund"
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrail.geometry}
                  position={[len3 / 100, 11, len2 / 100 + moverail]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                  scale={[10, len3 / 100, 10]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes.RoundHandrailCorner2.geometry}
                  position={[len3 / 100 - 4.3 + railfasciaadjust - handrailCablesU, 11, len2 / 100 + moverail]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  scale={[10, 10, 10]}
                />
              </>
            )}
          </>
        )}

        {props.handlaufmat == 'square' && (
          <>
            {
              <>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40Handrail'].geometry}
                  position={[(len1 + adjustvaluelen) / 100 + iAdjust + moverail, 11, 0]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[10, 10, (len1 + adjustvaluelen) / 100]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40HandrailCorner1'].geometry}
                  position={[(len1 + adjustvaluelen) / 100 - 4.45 + iAdjust + moverail * 2, 11, 0]}
                  scale={[10, 10, 10]}
                  rotation={[Math.PI, -1.57, 0]}
                  comment="Corner"
                />
                {props.form == 'i' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner1'].geometry}
                    position={[0 + 4.5 + railfasciaadjust + iAdjust + moverail * 2, 11, 0]}
                    scale={[10, 10, 10]}
                    rotation={[Math.PI, 1.57, 0]}
                    comment="Corner"
                  />
                )}
              </>
            }
            {(props.form == 'l' || props.form == 'u') && (
              <>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40Handrail'].geometry}
                  position={[0, 11, (len2 - adjustvaluelen) / 100]}
                  rotation={[0, 0, 0]}
                  scale={[10, 10, (len2 - adjustvaluelen) / 100]}
                />
                <group
                  position={[0 - 0.2, 11, 0]}
                  scale={[10, 10, 10]}
                  rotation={[0, -Math.PI / 2, 0]}
                  comment="corner40x40"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner1'].geometry}
                    position={[0, 0, 0]}
                    rotation={[0, 0, -Math.PI]}
                    comment="Corner"
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner2'].geometry}
                    position={[-0.02, 0, -0.02]}
                    rotation={[Math.PI, -1.57, 0]}
                  />
                </group>
                {props.form == 'l' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner2'].geometry}
                    position={[0, 11, (len2 - adjustvaluelen) / 100 - 4.2]}
                    scale={[10, 10, 10]}
                    rotation={[0, Math.PI, -Math.PI / 2]}
                  />
                )}
              </>
            )}
            {props.form == 'u' && (
              <>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40Handrail'].geometry}
                  position={[(len3 + adjustvaluelen) / 100 + moverail, 11, len2 / 100 + moverail]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[10, 10, len3 / 100]}
                />
                <group
                  position={[0, 11, len2 / 100 + 0.2 + moverail]}
                  scale={[10, 10, 10]}
                  rotation={[0, 0, 0]}
                  comment="corner40x40"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner1'].geometry}
                    position={[0, 0, 0]}
                    rotation={[0, 0, -Math.PI]}
                    comment="Corner"
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['40x40HandrailCorner2'].geometry}
                    position={[-0.02, 0, -0.02]}
                    rotation={[Math.PI, -1.57, 0]}
                  />
                </group>

                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['40x40HandrailCorner2'].geometry}
                  position={[
                    (len3 + adjustvaluelen) / 100 - 4.3 + moverail * 2 - handrailCablesU,
                    11,
                    len2 / 100 + moverail,
                  ]}
                  scale={[10, 10, 10]}
                  rotation={[Math.PI, -1.57, 0]}
                />
              </>
            )}
          </>
        )}

        {props.handlaufmat == '60x30' && (
          <>
            {
              <>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30Handrail'].geometry}
                  position={[(len1 + adjustvaluelen) / 100 + iAdjust, 11 - 0.1, 0]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[10, 6.66, len1 / 100]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30HandrailCorner1'].geometry}
                  position={[(len1 + adjustvaluelen) / 100 - 4.48 + iAdjust, 11 - 0.1, 0]}
                  scale={[10, 6.66, 10]}
                  rotation={[Math.PI, -1.57, 0]}
                />
                {props.form == 'i' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner1'].geometry}
                    position={[0 + 4.5 + iAdjust, 11 - 0.1, 0]}
                    scale={[10, 6.66, 10]}
                    rotation={[Math.PI, 1.57, 0]}
                  />
                )}
              </>
            }
            {(props.form == 'l' || props.form == 'u') && (
              <>
                <group
                  position={[0 - 0.1, 11 - 0.1, 0]}
                  scale={[10, 6.66, 10]}
                  rotation={[0, -Math.PI / 2, 0]}
                  comment="EckigCorner 30x60"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner1'].geometry}
                    position={[0, 0, 0.01 + 0.01]}
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner2'].geometry}
                    position={[-0.03, 0, -0.01]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30Handrail'].geometry}
                  position={[0, 11 - 0.1, (len2 - adjustvaluelen) / 100]}
                  rotation={[0, 0, 0]}
                  scale={[10, 6.66, (len2 - adjustvaluelen) / 100]}
                />
                {props.form == 'l' && (
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner2'].geometry}
                    position={[0, 11 - 0.1, (len2 - adjustvaluelen) / 100 - 4.2]}
                    scale={[10, 6.66, 10]}
                    rotation={[0, Math.PI, 0]}
                  />
                )}
              </>
            )}

            {props.form == 'u' && (
              <>
                <group
                  position={[0, 11 - 0.1, len2 / 100 + 0.1 + moverail]}
                  scale={[10, 6.66, 10]}
                  rotation={[0, 0, 0]}
                  comment="EckigCorner 30x60"
                >
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner1'].geometry}
                    position={[0, 0, 0.01 + 0.01]}
                  />
                  <mesh
                    material={materials.AluAltPhysicalEngine}
                    geometry={nodes['60x30HandrailCorner2'].geometry}
                    position={[-0.03, 0, -0.01]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30Handrail'].geometry}
                  position={[(len3 + adjustvaluelen) / 100, 11 - 0.1, len2 / 100 + moverail]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[10, 6.66, len3 / 100]}
                />
                <mesh
                  material={materials.AluAltPhysicalEngine}
                  geometry={nodes['60x30HandrailCorner1'].geometry}
                  position={[(len3 + adjustvaluelen) / 100 - 4.3, 11 - 0.1, len2 / 100 + moverail]}
                  scale={[10, 6.66, 10]}
                  rotation={[0, -Math.PI / 2, 0]}
                />
              </>
            )}
          </>
        )}
      </>
    );
  }

  return (
    <>
      {renderpostsystem()}
      {floorrender()}
      {renderhandrail()}
      {renderfillings()}
      {rendersecondmodel()}
      {measurementrender()}
      {(props.montageart != 'top' || props.postshape == '60x30') && renderthirdmodelcornerbrackets()}
    </>
  );
}

export default Qline;
